webpackJsonp([1],{

/***/ "+QSb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Noise_K.5befd64.png";

/***/ }),

/***/ "3SyN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5vhj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Noise_X.a70fdac.png";

/***/ }),

/***/ "AIPa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DhZQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Noise_KK.687907f.png";

/***/ }),

/***/ "ErG9":
/***/ (function(module, exports) {

module.exports = [{"name":"Noise_K","tags":["one_way","key_pinning"],"description":"Noise_K is a one-way handshake pattern (in which only the client sends application data to the server and the server never replies) where:<ol><li>the client already knows the server's public key</li><li>the server already knows the client's public key</li></ol>"},{"name":"Noise_N","tags":["one_way","key_pinning"],"description":"Noise_N is a one-way handshake pattern (in which only the client sends application data to the server and the server never replies) where:<ol><li>the client already knows the server's public key</li><li>the client is not authenticated as part of the handshake</li></ol>"},{"name":"Noise_X","tags":["one_way","key_pinning","PKI"],"description":"Noise_X is a one-way handshake pattern (in which only the client sends application data to the server and the server never replies) where:<ol><li>the server receives the client's public key as part of the handshake</li><li>the client already knows the server's public key</li></ol>"},{"name":"Noise_NNpsk2","tags":["two_way","psk"],"description":"Noise_NNpsk2 is a handshake pattern where both the client and the server already share a 32-byte secret."},{"name":"Noise_KK","tags":["two_way","key_pinning"],"description":"Noise_KK is a handshake pattern where both peers already know each other's public key prior to the handshake."},{"name":"Noise_IK","tags":["two_way","key_pinning"],"description":"Noise_IK is a handshake pattern where the client already knows the server's public key prior to the handshake, and the client sends its static public key as part of the handshake."},{"name":"Noise_NK","tags":["two_way","key_pinning"],"description":"Noise_NK is a handshake pattern similar to mobile device applications connecting to webservers using <strong>public-key pinning</strong>. The static public key of the server is hardcoded on the client-side of the connection, thanks to this it is not \"sent\" by the server during the connection, but still used as part of the cryptographic computations. The client is not authenticated"},{"name":"Noise_NX","tags":["two_way","PKI"],"description":"Noise_NX is a handshake pattern similar to a typical <strong>browser ↔ HTTPS server</strong> scenario where the client does not authenticate itself and the server authenticates its public key via a signature from an authoritative signing key."},{"name":"Noise_XX","tags":["two_way","PKI"],"description":"Noise_XX is a handshake pattern similar to the typical <strong>browser ↔ HTTPS server</strong> scenario where both the client and the server authenticate themselves via a static public key along with a proof from an (or two different) authoritative signing key(s)."}]

/***/ }),

/***/ "HD75":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Noise_N.0d710ff.png";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./src/assets/patterns.json
var patterns = __webpack_require__("ErG9");
var patterns_default = /*#__PURE__*/__webpack_require__.n(patterns);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


window.hljs = __webpack_require__("V8mf");

/* harmony default export */ var App = ({
  data: function data() {
    return {
      patterns: []
    };
  },
  beforeMount: function beforeMount() {
    this.patterns = patterns_default.a;
  },
  mounted: function mounted() {
    hljs.initHighlightingOnLoad();
  },
  updated: function updated() {
    document.querySelectorAll("pre").forEach(function (a) {
      hljs.highlightBlock(a);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fff7999","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"level"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"level-right"},[_c('p',{staticClass:"level-item"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1),_vm._v(" "),_c('p',{staticClass:"level-item"},[_c('router-link',{staticClass:"button is-success",attrs:{"to":"/get_started"}},[_vm._v("Get Started")])],1),_vm._v(" "),_c('p',{staticClass:"level-item"},[_c('router-link',{attrs:{"to":"/protocol/Overview"}},[_vm._v("Protocol")])],1),_vm._v(" "),_c('p',{staticClass:"level-item"},[_c('router-link',{attrs:{"to":"/library/Overview"}},[_vm._v("Cryptographic Library")])],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-one-quarter"},[_c('aside',{staticClass:"menu"},[_c('p',{staticClass:"menu-label"},[_vm._v("\n              General\n            ")]),_vm._v(" "),_c('ul',{staticClass:"menu-list"},[_c('li',[_c('router-link',{class:{ 'is-active': _vm.$route.name == 'GetStarted' },attrs:{"to":"/get_started"}},[_vm._v("Get Started")])],1)]),_vm._v(" "),_c('p',{staticClass:"menu-label"},[_vm._v("\n              Protocol\n            ")]),_vm._v(" "),_c('ul',{staticClass:"menu-list"},[_c('li',[_c('router-link',{class:{ 'is-active': _vm.$route.name == 'protocolOverview' },attrs:{"to":"/protocol/Overview"}},[_vm._v("Overview")])],1),_c('li',[_c('router-link',{class:{ 'is-active': _vm.$route.name == 'Keys' },attrs:{"to":"/protocol/Keys"}},[_vm._v("Keys in Disco")])],1),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('li',[_c('ul',_vm._l((_vm.patterns),function(pattern){return _c('li',[_c('router-link',{class:{ 'is-active': _vm.$route.name == pattern.name },attrs:{"to":'/protocol/' + pattern.name}},[_vm._v(_vm._s(pattern.name))])],1)}),0)])]),_vm._v(" "),_c('p',{staticClass:"menu-label"},[_vm._v("\n              Cryptographic Library\n            ")]),_vm._v(" "),_c('ul',{staticClass:"menu-list"},[_c('li',[_c('router-link',{class:{ 'is-active': _vm.$route.name == 'libraryOverview' },attrs:{"to":"/library/Overview"}},[_vm._v("Overview")])],1),_vm._v(" "),_c('li',[_c('ul',[_c('li',[_c('router-link',{class:{ 'is-active': _vm.$route.name == 'Hashing' },attrs:{"to":"/library/Hashing"}},[_vm._v("Hashing")])],1),_vm._v(" "),_c('li',[_c('router-link',{class:{ 'is-active': _vm.$route.name == 'Encryption' },attrs:{"to":"/library/Encryption"}},[_vm._v("Encryption")])],1),_vm._v(" "),_c('li',[_c('router-link',{class:{ 'is-active': _vm.$route.name == 'IntegrityProtection' },attrs:{"to":"/library/IntegrityProtection"}},[_vm._v("Integrity Protection")])],1),_vm._v(" "),_c('li',[_c('router-link',{class:{ 'is-active': _vm.$route.name == 'DerivingKeys' },attrs:{"to":"/library/DerivingKeys"}},[_vm._v("Deriving Keys")])],1),_vm._v(" "),_c('li',[_c('router-link',{class:{ 'is-active': _vm.$route.name == 'Signing' },attrs:{"to":"/library/Signing"}},[_vm._v("Signing")])],1),_vm._v(" "),_c('li',[_c('router-link',{class:{ 'is-active': _vm.$route.name == 'RandomNumbers' },attrs:{"to":"/library/RandomNumbers"}},[_vm._v("Random Numbers")])],1),_vm._v(" "),_c('li',[_c('router-link',{class:{ 'is-active': _vm.$route.name == 'PasswordHashing' },attrs:{"to":"/library/PasswordHashing"}},[_vm._v("Storing Password")])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('router-view')],1)])])]),_vm._v(" "),_vm._m(4)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('div',{staticClass:"navbar-brand"},[_c('a',{staticClass:"navbar-item",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"/static/discoblue.png","alt":"Disco: a modern plug-and-play secure protocol and a cryptographic library"}})])]),_vm._v(" "),_c('h1',[_vm._v("libdisco")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"level-item"},[_c('a',{attrs:{"href":"https://github.com/mimoo/disco/","target":"_blank"}},[_vm._v("Source Code")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"level-item"},[_c('a',{attrs:{"href":"https://www.cryptologie.net/contact","target":"_blank"}},[_vm._v("Contact")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"disco.html","target":"_blank"}},[_vm._v("Specification")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_c('strong',[_vm._v("Disco")]),_vm._v(" and "),_c('strong',[_vm._v("libdisco")]),_vm._v(" by "),_c('a',{attrs:{"href":"https://www.cryptologie.net"}},[_vm._v("David Wong")]),_vm._v(".\n        ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("ej5v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Quizz.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// this quizz works mostly by elimination.
var questionsreponses = [{
  q: "Does your protocol involve only clients talking to a server (where the server doesn't reply back)?",
  ryes: "one_way",
  rno: "two_way"
}, {
  q: "Does your protocol involve a client and a server already sharing a secret (a symmetric key)?",
  ryes: "psk"
}, {
  q: "Does at least one of your peer already know the public key of the other peer?",
  ryes: "key_pinning"
}, {
  q: "Is at least one of your peer's public key signed by a trusted authority?",
  ryes: "PKI"
}, {
  q: "Do your peers have an out-of-band way to compare a string or a large number?",
  ryes: "out_of_band"
}];

/* harmony default export */ var Quizz = ({
  name: 'Quizz',
  data: function data() {
    return {
      question: 'wait',
      questionId: 0,
      tags: [],
      finished: false,
      results: []
    };
  },


  methods: {
    resetQuizz: function resetQuizz(e) {
      this.results = [];
      this.questionId = 0;
      this.question = questionsreponses[0]["q"];
      this.tags = [];
      this.finished = false;
      e.preventDefault();
    },
    quizzNext: function quizzNext() {
      this.questionId++;
      if (this.questionId >= questionsreponses.length) {
        this.displayResults();
        return;
      }
      this.question = questionsreponses[this.questionId]["q"];
    },
    quizzYes: function quizzYes(e) {
      if (questionsreponses[this.questionId].hasOwnProperty("ryes")) {
        this.tags.push(questionsreponses[this.questionId]["ryes"]);
      }
      this.quizzNext();
      e.preventDefault();
    },
    quizzNo: function quizzNo(e) {
      if (questionsreponses[this.questionId].hasOwnProperty("rno")) {
        this.tags.push(questionsreponses[this.questionId]["rno"]);
      }
      this.quizzNext();
      e.preventDefault();
    },
    displayResults: function displayResults() {
      var _this = this;

      this.finished = true;
      this.question = this.tags;
      patterns_default.a.forEach(function (pattern) {
        var fitting = true;
        pattern.tags.forEach(function (tag) {
          console.log("test", tag, "for", _this.tags, " result:", _this.tags.includes(tag));
          if (!_this.tags.includes(tag)) {
            fitting = false;
          }
        });
        if (fitting) {
          console.log("fit:", pattern);
          _this.results.push(pattern);
        }
      });
      if (this.results.length == 0) {
        this.results.push({ name: "No pattern matching", description: "You need to answer yes to some questions :)" });
      }
    }
  },

  mounted: function mounted() {
    this.question = questionsreponses[0]["q"];
    document.querySelector("progress").max = questionsreponses.length;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-740ab518","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quizz.vue
var Quizz_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"message"},[_c('div',{staticClass:"message-body"},[_c('div',{staticClass:"field displayBox"},[(_vm.finished)?_c('div',_vm._l((_vm.results),function(result){return _c('div',{staticClass:"box"},[_c('div',{staticClass:"content"},[_c('p',[_c('strong',[_c('router-link',{attrs:{"to":'/protocol/' + result.name}},[_vm._v(_vm._s(result.name))])],1),_vm._v(" "),_vm._l((result.tags),function(tag){return _c('span',{staticClass:"tag"},[_vm._v(_vm._s(tag))])})],2),_c('div',{domProps:{"innerHTML":_vm._s(result.description)}}),_vm._v(" "),_c('p')])])}),0):_c('strong',[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.question))])]),_vm._v(" "),_c('div',{staticClass:"field is-grouped"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-success",attrs:{"href":"some/link","disabled":_vm.finished},on:{"click":_vm.quizzYes}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-danger",attrs:{"href":"some/link","disabled":_vm.finished},on:{"click":_vm.quizzNo}},[_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-text",on:{"click":_vm.resetQuizz}},[_vm._v("Reset the Quizz")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('progress',{staticClass:"progress is-small",attrs:{"max":"100"},domProps:{"value":_vm.questionId}})])])}
var Quizz_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-times"})])}]
var Quizz_esExports = { render: Quizz_render, staticRenderFns: Quizz_staticRenderFns }
/* harmony default export */ var components_Quizz = (Quizz_esExports);
// CONCATENATED MODULE: ./src/components/Quizz.vue
function Quizz_injectStyle (ssrContext) {
  __webpack_require__("AIPa")
}
var Quizz_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Quizz___vue_template_functional__ = false
/* styles */
var Quizz___vue_styles__ = Quizz_injectStyle
/* scopeId */
var Quizz___vue_scopeId__ = "data-v-740ab518"
/* moduleIdentifier (server only) */
var Quizz___vue_module_identifier__ = null
var Quizz_Component = Quizz_normalizeComponent(
  Quizz,
  components_Quizz,
  Quizz___vue_template_functional__,
  Quizz___vue_styles__,
  Quizz___vue_scopeId__,
  Quizz___vue_module_identifier__
)

/* harmony default export */ var src_components_Quizz = (Quizz_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LandingPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LandingPage = ({
  name: 'LandingPage',
  components: {
    Quizz: src_components_Quizz
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-472a44c3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPage.vue
var LandingPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',[_vm._v("and the standard way of setting up a client with a libdisco config:")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('p',[_vm._v("it's that simple! Check out the "),_c('router-link',{attrs:{"to":"/get_started"}},[_vm._v("get started")]),_vm._v(" section for more information.")],1),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('Quizz'),_vm._v(" "),_c('p',[_vm._v("To make use of the "),_vm._m(10),_vm._v(", check our "),_c('router-link',{attrs:{"to":"/library/Overview"}},[_vm._v("overview here")]),_vm._v(" or directly access them through the menu on the left.")],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13)],1)}
var LandingPage_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-info is-bold"},[_c('div',{staticClass:"hero-body"},[_c('h1',{staticClass:"title"},[_c('strong',[_vm._v("libdisco")])]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("\n          libdisco is a "),_c('strong',[_vm._v("modern plug-and-play secure protocol")]),_vm._v(" and a "),_c('strong',[_vm._v("cryptographic library")]),_vm._v(" in "),_c('strong',[_vm._v("Golang")]),_vm._v(". It offers different ways of encrypting communications, as well as different cryptographic primitives for all of an application's needs.\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"message is-danger",staticStyle:{"margin":"20px 0"}},[_c('div',{staticClass:"message-header"},[_c('p',[_vm._v("Warning")])]),_vm._v(" "),_c('div',{staticClass:"message-body"},[_vm._v("\n        libdisco is "),_c('strong',[_vm._v("experimental")]),_vm._v(". It has not been thoroughly reviewed and relies on an unstable specification. It should not be used in production.\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("libdisco")]),_vm._v(" is a library built by merging the "),_c('a',{attrs:{"href":"https://noiseprotocol.org"}},[_vm._v("Noise protocol framework")]),_vm._v(" and the "),_c('a',{attrs:{"href":"https://strobe.sourceforge.io"}},[_vm._v("Strobe protocol framework")]),_vm._v(". This means that it supports a subset of Noise's handshakes while offering the cryptographic primitive Strobe has to offer. In other words, you can use libdisco to securely connect peers together, or to do basic cryptographic operations like hashing or encrypting.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"main_list"},[_c('li',[_vm._v("The "),_c('span',[_vm._v("secure protocol parts")]),_vm._v(" are based on the "),_c('a',{attrs:{"href":"/disco.html"}},[_c('i',{staticClass:"far fa-file-alt"}),_vm._v(" Disco specification")]),_vm._v(" which extends the "),_c('strong',[_vm._v("Noise protocol framework")]),_vm._v(".")]),_vm._v(" "),_c('li',[_vm._v("The "),_c('span',[_vm._v("symmetric cryptographic primitives")]),_vm._v(" are all based on the "),_c('strong',[_vm._v("Strobe protocol framework")]),_vm._v(" which only relies on the "),_c('strong',[_vm._v("SHA-3")]),_vm._v(" permutation (called "),_c('strong',[_vm._v("keccak-f")]),_vm._v(").")]),_vm._v(" "),_c('li',[_vm._v("The "),_c('span',[_vm._v("asymmetric cryptographic primitives")]),_vm._v(" ("),_c('strong',[_vm._v("X25519")]),_vm._v(" and "),_c('strong',[_vm._v("ed25519")]),_vm._v(") are based on the "),_c('a',{attrs:{"href":"https://golang.org/"}},[_vm._v("golang")]),_vm._v(" standard library.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n      Want to know more about the technical details? "),_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=bTGLO4obxco","target":"_blank"}},[_vm._v("Watch our "),_c('i',{staticClass:"fab fa-youtube"}),_vm._v(" presentation at Black Hat Europe 2017")]),_vm._v(" and read our "),_c('a',{attrs:{"href":"https://eprint.iacr.org/2019/180"}},[_c('i',{staticClass:"fas fa-file-alt"}),_vm._v(" whitepaper")]),_vm._v(".\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("To set it up, follow "),_c('a',{attrs:{"href":"https://golang.org/pkg/net/","target":"_blank"}},[_vm._v("Golang's net/conn")]),_vm._v(" standard way of setting up a server with a libdisco config:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("serverConfig := libdisco.Config{\n  HandshakePattern: libdisco.NoiseNK,\n  KeyPair:          serverKeyPair,\n}\nlistener, err := libdisco.Listen(\"tcp\", \"127.0.0.1:6666\", &serverConfig)\nserver, err := listener.Accept()")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("clientConfig := libdisco.Config{\n  HandshakePattern: libdisco.NoiseNK,\n  RemoteKey:        serverKey,\n}\nclient, err := libdisco.Dial(\"tcp\", \"127.0.0.1:6666\", &clientConfig)\n")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-warning",staticStyle:{"margin-bottom":"40px"}},[_c('div',{staticClass:"hero-body"},[_c('h1',{staticClass:"title",staticStyle:{"margin-bottom":"0"}},[_c('strong',[_vm._v("Why use libdisco?")])]),_vm._v(" "),_c('ul',{staticStyle:{"font-size":"18px"}},[_c('li',[_vm._v("libdisco's source code is around "),_c('strong',[_vm._v("1000 lines of code")]),_vm._v(" without the cryptographic primitives. Around 2000 lines of code with the symmetric cryptographic primitive (Strobe), and 4000 lines of code with X25519 (for key exchanges). It makes it easy to audit and a pleasure to fit into tiny devices.")]),_vm._v(" "),_c('li',[_vm._v("The protocol relies on the solid "),_c('strong',[_vm._v("Noise protocol framework")]),_vm._v(" which is used by many others including WhatsApp, Wireguard, the Bitcoin Lightning Network, ...")]),_vm._v(" "),_c('li',[_vm._v("The library relies only on "),_c('strong',[_vm._v("two cryptographic primitives")]),_vm._v(" and nothing else: "),_c('strong',[_vm._v("Curve25519")]),_vm._v(" and the "),_c('strong',[_vm._v("SHA-3")]),_vm._v(" permutation.")]),_vm._v(" "),_c('li',[_vm._v("libdisco is "),_c('strong',[_vm._v("flexible")]),_vm._v(". libdisco supports many different ways of securely connecting two peers together while avoiding complex certificates or public key infrastructures (unless you want to use them).")]),_vm._v(" "),_c('li',[_vm._v("libdisco is "),_c('strong',[_vm._v("versatile")]),_vm._v(". While it allows you to securely link peers together, it is also an entire cryptographic library!")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("To make use of the "),_c('strong',[_c('i',{staticClass:"fas fa-exchange-alt",attrs:{"aria-hidden":"true"}}),_vm._v("\n    protocol parts")]),_vm._v(", you must first choose how you want to authenticate the connection. For that, it's easy! We have made a "),_c('strong',[_vm._v("small quizz")]),_vm._v(" for you bellow, but if you already know what you want you can directly click on your favorite way of doing this in the menu under \"protocol\" (Noise_NK, Noise_XX, ...) and copy the usage examples.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',[_c('i',{staticClass:"fa fa-wrench",attrs:{"aria-hidden":"true"}}),_vm._v("\n    cryptographic library")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("To learn more about it, you can read "),_c('a',{attrs:{"href":"https://www.cryptologie.net/article/432/disco/","target":"_blank"}},[_c('i',{staticClass:"fas fa-newspaper"}),_vm._v(" this blog post")]),_vm._v(" or watch our "),_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=bTGLO4obxco","target":"_blank"}},[_c('i',{staticClass:"fab fa-youtube"}),_vm._v(" presentation at Black Hat Europe 2017")]),_vm._v(" .")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you want help, head to the "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/issues"}},[_c('i',{staticClass:"fa fa-question",attrs:{"aria-hidden":"true"}}),_vm._v("\n    issues on github")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you want to stay tuned on what we're doing, we don't have a mailing list but we have better: "),_c('a',{attrs:{"href":"https://www.reddit.com/r/discocrypto/"}},[_c('i',{staticClass:"fab fa-reddit-square"}),_vm._v(" a subreddit over at r/discocrypto")]),_vm._v(".")])}]
var LandingPage_esExports = { render: LandingPage_render, staticRenderFns: LandingPage_staticRenderFns }
/* harmony default export */ var components_LandingPage = (LandingPage_esExports);
// CONCATENATED MODULE: ./src/components/LandingPage.vue
function LandingPage_injectStyle (ssrContext) {
  __webpack_require__("3SyN")
}
var LandingPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LandingPage___vue_template_functional__ = false
/* styles */
var LandingPage___vue_styles__ = LandingPage_injectStyle
/* scopeId */
var LandingPage___vue_scopeId__ = "data-v-472a44c3"
/* moduleIdentifier (server only) */
var LandingPage___vue_module_identifier__ = null
var LandingPage_Component = LandingPage_normalizeComponent(
  LandingPage,
  components_LandingPage,
  LandingPage___vue_template_functional__,
  LandingPage___vue_styles__,
  LandingPage___vue_scopeId__,
  LandingPage___vue_module_identifier__
)

/* harmony default export */ var src_components_LandingPage = (LandingPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7796364f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GetStarted.vue
var GetStarted_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("Usages help can be found through-out this website. There are two important parts to libdisco:")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("the protocol")]),_vm._v(". libdisco allows you to setup a secure channel between two endpoints to encrypt their communication. More information is available in the "),_c('router-link',{attrs:{"to":"/protocol/Overview"}},[_vm._v("protocol")]),_vm._v(" part of this documentation.")],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("the library")]),_vm._v(". libdisco exports several cryptographic functions to hash, derive keys, encrypt, authenticate, ... usage example are available in the "),_c('router-link',{attrs:{"to":"/library/Overview"}},[_vm._v("cryptographic library")]),_vm._v(" part of this documentation.")],1)]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',[_vm._v("\n\t\tand import it in your application:\n\t\t")]),_vm._v(" "),_vm._m(4)])}
var GetStarted_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"title"},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" Get Started")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("General documentation for the protocol parts of libdisco can be found on "),_c('a',{attrs:{"href":"https://godoc.org/github.com/mimoo/disco/libdisco"}},[_c('img',{staticStyle:{"vertical-align":"text-top"},attrs:{"src":"https://godoc.org/github.com/mimoo/disco/libdisco?status.svg","alt":"GoDoc"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("To install the package simply use "),_c('code',[_vm._v("go get")]),_vm._v(":")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("\ngo get github.com/mimoo/disco/libdisco\n\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("package main\n\nimport(\n  \"github.com/mimoo/disco/libdisco\"\n)")])])}]
var GetStarted_esExports = { render: GetStarted_render, staticRenderFns: GetStarted_staticRenderFns }
/* harmony default export */ var GetStarted = (GetStarted_esExports);
// CONCATENATED MODULE: ./src/components/GetStarted.vue
var GetStarted_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var GetStarted___vue_template_functional__ = false
/* styles */
var GetStarted___vue_styles__ = null
/* scopeId */
var GetStarted___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GetStarted___vue_module_identifier__ = null
var GetStarted_Component = GetStarted_normalizeComponent(
  __vue_script__,
  GetStarted,
  GetStarted___vue_template_functional__,
  GetStarted___vue_styles__,
  GetStarted___vue_scopeId__,
  GetStarted___vue_module_identifier__
)

/* harmony default export */ var components_GetStarted = (GetStarted_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/handshakes/Overview.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Overview = ({
  name: 'protocolOverview',
  components: {
    Quizz: src_components_Quizz
  },
  data: function data() {
    return {
      patterns: []
    };
  },
  beforeMount: function beforeMount() {
    this.patterns = patterns_default.a;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d23650e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handshakes/Overview.vue
var Overview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('Quizz'),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('p',[_vm._v("\n\tThe following example use the Noise_NK handshake where the client is not authenticated and the server's key is known to the client in advance.\n\t")]),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_c('p',[_vm._v("The following is a list of all the supported handshake patterns and a brief description for each of them.")]),_vm._v(" "),_vm._l((_vm.patterns),function(pattern){return _c('div',{staticClass:"box"},[_c('div',{staticClass:"content"},[_c('p',[_c('strong',[_c('router-link',{attrs:{"to":'/handshakes/' + pattern.name}},[_vm._v(_vm._s(pattern.name))])],1),_vm._v(" "),_vm._l((pattern.tags),function(tag){return _c('span',{staticClass:"tag"},[_vm._v(_vm._s(tag))])})],2),_c('div',{domProps:{"innerHTML":_vm._s(pattern.description)}}),_vm._v(" "),_c('p')])])}),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26)],2)}
var Overview_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"title"},[_c('i',{staticClass:"fas fa-exchange-alt"}),_vm._v(" Protocol Overview")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("libdisco")]),_vm._v("'s protocol is based on the "),_c('a',{attrs:{"href":"/disco.html"}},[_c('i',{staticClass:"far fa-file-alt"}),_vm._v(" Disco extension")]),_vm._v(" of the "),_c('a',{attrs:{"href":"https://noiseprotocol.org"}},[_vm._v("Noise protocol framework")]),_vm._v(". What this means to you is that the library supports a subset (although potentially all) of the handshakes that are specified in the Noise protocol framework.\n\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n\t\t\tTheses "),_c('strong',[_vm._v("handshakes")]),_vm._v(" are different ways to "),_c('strong',[_vm._v("setup a secure connection")]),_vm._v(" that your application can use to encrypt data between two endpoints. They have names like "),_c('code',[_vm._v("Noise_XX")]),_vm._v(" and "),_c('code',[_vm._v("Noise_NK")]),_vm._v(" and are explained (along with examples on how to use them) in this documentation. See the "),_c('i',{staticClass:"fa fa-bars",attrs:{"aria-hidden":"true"}}),_vm._v(" menu on the left. "),_c('br'),_vm._v("\n\t\t\tBy the way, the letters after the \"Noise_\" have a meaning! You do not have to learn it but it can help you in your choice. "),_c('a',{attrs:{"href":"https://noiseprotocol.org/noise.html#one-way-patterns"}},[_vm._v("See the Noise specification for more information")]),_vm._v(".\n\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n\t\t\tIn addition, we provide the following short "),_c('strong',[_vm._v("Quizz")]),_vm._v(" to help you figure out what is the best way for you to connect your endpoints (or "),_c('strong',[_vm._v("peers")]),_vm._v(") securely.\n\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Configuration")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("General documentation for the protocol parts of libdisco can be found on "),_c('a',{attrs:{"href":"https://godoc.org/github.com/mimoo/disco/libdisco"}},[_c('img',{staticStyle:{"vertical-align":"text-top"},attrs:{"src":"https://godoc.org/github.com/mimoo/disco/libdisco?status.svg","alt":"GoDoc"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("A "),_c('code',[_vm._v("libdisco.Config")]),_vm._v(" is mandatory for setting up both clients and servers.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("type Config struct {\n  HandshakePattern     noiseHandshakeType\n  KeyPair              *KeyPair\n  RemoteKey            []byte\n  Prologue             []byte\n  StaticPublicKeyProof []byte\n  PublicKeyVerifier    func(publicKey, proof []byte) bool\n  PreSharedKey         []byte\n  HalfDuplex           bool\n}")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("HandshakePattern")]),_vm._v(": You will have to choose a handshake pattern from the list of implemented patterns first. We've included some explanations in the documentation and on this page, but the Noise specification contains the most amount of information about these. If the client and the server do not choose the same handshake pattern, they will not succeed in creating a secure channel. (If something is not clear, or if a pattern has not been implemented, please use the issues on this repo to tell us.)\n\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("KeyPair")]),_vm._v(": if the handshake pattern chosen requires the peer to be initialized with a static key (because it will send its static key to the other peer during the handshake), this should be filled with a X25519 KeyPair structure. Several utility functions exist to create and load one, see "),_c('code',[_vm._v("GenerateKeypair()")]),_vm._v(", "),_c('code',[_vm._v("GenerateAndSaveDiscoKeyPair()")]),_vm._v(" and "),_c('code',[_vm._v("LoadDiscoKeyPair()")]),_vm._v(" in the documentation.\n\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("RemoteKey")]),_vm._v(": if the handshake pattern chosen requires the peer to be initialized with the static key of the other peer (because it is supposed to know its peer's static key. Think about public-key pinning). This should be a 32-byte X25519 public key. A peer's public key can be obtained via the "),_c('code',[_vm._v("KeyPair.ExtractPublicKey()")]),_vm._v(" function.\n\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Prologue")]),_vm._v(": any messages that have been exchanged between a client and a server, prior to the encryption of the channel via Disco, can be authenticated via the prologue. This means that if a man-in-the-middle attacker has removed, added or re-ordered messages prior to setting up a Disco channel, the client and the servers will not be able to setup a secure channel with Noise (and thus will inform both peers that the prologue information is not the same on both sides). To use this, simply concatenate all these messages (on both the client and the server) and pass them in the prologue value.\n\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("StaticPublicKeyProof")]),_vm._v(": if the handshake pattern chosen has the peer send its static public key at some point in the handshake, the peer might need to provide a \"proof\" that the public key is \"legit\". For example, the "),_c('code',[_vm._v("StaticPublicKeyProof")]),_vm._v(" can be a signature over the peer's static public key from an authoritative root key. This \"proof\" will be sent as part of the handshake, possibly non-encrypted and visible to passive observers. More information is available in the Disco Keys section.\n\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("PublicKeyVerifier")]),_vm._v(": if the handshake pattern chosen has the peer receive a static public key at some point in the handshake, then the peer needs a function to verify the validity of the received key. During the handshake a \"proof\" might have been sent. "),_c('code',[_vm._v("PublicKeyVerifier")]),_vm._v(" is a callback function that must be implemented by the application using Disco and that will be called on both the static public key that has been received and any payload that has been received so far (usually the payload sent by the previous "),_c('code',[_vm._v("StaticPublicKeyProof")]),_vm._v(" function). If this function returns true, the handshake will continue. Otherwise the handshake will fail. More information is available in the Disco Keys section.\n\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("PreSharedKey")]),_vm._v(": if the handshake pattern chosen requires both peers to be aware of a shared secret (of 32-byte), this pre-shared secret must be shared in the configuration prior to starting the handshake.\n\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("HalfDuplex")]),_vm._v(": In some situation, one of the peer might be constrained by the size of its memory. In such scenarios, communication over a single writing channel might be a solution. Disco provides half-duplex channels where the client and the server take turn to write or read on the secure channel. For this to work this value must be set to true on both side of the connection. The server and client MUST NOT write or read on the secure channel at the same time.\n\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"message is-info"},[_c('div',{staticClass:"message-header"},[_c('p',[_vm._v("Authenticated?")])]),_vm._v(" "),_c('div',{staticClass:"message-body"},[_vm._v("\n\t\t    What do we mean by "),_c('strong',[_vm._v("authenticated")]),_vm._v("? When you visit "),_c('code',[_vm._v("https://www.google.com")]),_vm._v(", your browser authenticates the webserver (and thus "),_c('code',[_vm._v("google.com")]),_vm._v(" is authenticated) but the browser is generally not authenticated (or it is later via a simple form asking you for credentials). To authenticate "),_c('code',[_vm._v("google.com")]),_vm._v(", the webserver provides a signature from an authority that the web browser trust and thus can verify.\n\t\t  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Server")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n\tSimply use the "),_c('code',[_vm._v("Listen()")]),_vm._v(" and "),_c('code',[_vm._v("Accept()")]),_vm._v(" paradigm. You then get an object implementing the "),_c('code',[_vm._v("net.Conn")]),_vm._v(" interface. You can then "),_c('code',[_vm._v("Write()")]),_vm._v(" and "),_c('code',[_vm._v("Read()")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("package main\n\nimport (\n\t\"fmt\"\n\n\t\"github.com/mimoo/disco/libdisco\"\n)\n\nfunc main() {\n\n\tserverKeyPair := libdisco.GenerateKeypair(nil)\n\n\tserverConfig := libdisco.Config{\n\t\tHandshakePattern: libdisco.NoiseNK,\n\t\tKeyPair:          serverKeyPair,\n\t}\n\n\tlistener, err := libdisco.Listen(\"tcp\", \"127.0.0.1:6666\", &serverConfig)\n\tif err != nil {\n\t\tfmt.Println(\"cannot setup a listener on localhost:\", err)\n\t\treturn\n\t}\n\taddr := listener.Addr().String()\n\tfmt.Println(\"listening on:\", addr)\n\tfmt.Println(\"server's public key:\", serverKeyPair.ExportPublicKey())\n\n\tserver, err := listener.Accept()\n\tif err != nil {\n\t\tfmt.Println(\"server cannot accept()\")\n\t\treturn\n\t}\n\tdefer server.Close()\n\n\tbuf := make([]byte, 100)\n\tfor {\n\t\tn, err := server.Read(buf)\n\t\tif err != nil {\n\t\t\tfmt.Println(\"server can't read on socket\", err)\n\t\t\treturn\n\t\t}\n\t\tfmt.Println(\"server received some data:\", string(buf[:n]))\n\t}\n}")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Client")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The client can simply use the "),_c('code',[_vm._v("Dial()")]),_vm._v(" paradigm using the public key of the server:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("package main\n\nimport (\n\t\"encoding/hex\"\n\t\"fmt\"\n\n\t\"github.com/mimoo/disco/libdisco\"\n)\n\nfunc main() {\n\t// replace this with the server's public key!\n\tserverKey, _ := hex.DecodeString(\"e424214ab16f56def7778e9a3d36d891221c4f5b38c8b2679ccbdaed5c27e735\")\n\tclientConfig := libdisco.Config{\n\t\tHandshakePattern: libdisco.NoiseNK,\n\t\tRemoteKey:        serverKey,\n\t}\n\n\tclient, err := libdisco.Dial(\"tcp\", \"127.0.0.1:6666\", &clientConfig)\n\tif err != nil {\n\t\tfmt.Println(\"client can't connect to server:\", err)\n\t\treturn\n\t}\n\tdefer client.Close()\n\n\tfor {\n\t\tvar in string\n\t\tfmt.Scanf(\"%s\", &in)\n\t\t_, err = client.Write([]byte(in))\n\t\tif err != nil {\n\t\t\tfmt.Println(\"client can't write on socket:\", err)\n\t\t}\n\t}\n}")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Handshake Patterns")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Examples")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Further examples for all supported handshake patterns can be found in "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/tree/master/libdisco/examples","target":"_blank"}},[_vm._v("the github repository")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you need help, head to the "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/issues"}},[_c('i',{staticClass:"fa fa-question",attrs:{"aria-hidden":"true"}}),_vm._v(" issues on github")]),_vm._v(" or the "),_c('a',{attrs:{"href":"https://www.reddit.com/r/discocrypto/"}},[_c('i',{staticClass:"fab fa-reddit-square"}),_vm._v(" subreddit over at r/discocrypto")]),_vm._v(".")])}]
var Overview_esExports = { render: Overview_render, staticRenderFns: Overview_staticRenderFns }
/* harmony default export */ var handshakes_Overview = (Overview_esExports);
// CONCATENATED MODULE: ./src/components/handshakes/Overview.vue
var Overview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Overview___vue_template_functional__ = false
/* styles */
var Overview___vue_styles__ = null
/* scopeId */
var Overview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Overview___vue_module_identifier__ = null
var Overview_Component = Overview_normalizeComponent(
  Overview,
  handshakes_Overview,
  Overview___vue_template_functional__,
  Overview___vue_styles__,
  Overview___vue_scopeId__,
  Overview___vue_module_identifier__
)

/* harmony default export */ var components_handshakes_Overview = (Overview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Keys.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Keys = ({
	name: 'Noise_KK',
	data: function data() {
		return {
			pattern: {}
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		patterns_default.a.forEach(function (pattern) {
			if (pattern.name == "Noise_KK") {
				_this.pattern = pattern;
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b8a595e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Keys.vue
var Keys_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("Disco makes use of several key pairs:")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',[_vm._v("Imagine a handshake pattern like "),_c('router-link',{attrs:{"to":"/protocol/Noise_NX"}},[_vm._v("Noise_NX")]),_vm._v(" where only the server sends its static public key along with a proof.")],1),_vm._v(" "),_c('p',[_vm._v("1. create the root signing key:")]),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('p',[_vm._v("2. sign the server's static public key:")]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('p',[_vm._v("3. configure the server to send its static public key along with its proof:")]),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('p',[_vm._v("5. And that's it!")]),_vm._v(" "),_vm._m(15)])}
var Keys_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"title"},[_c('i',{staticClass:"fas fa-exchange-alt"}),_vm._v(" Disco Keys")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" The Different Keys")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('strong',[_vm._v("Ephemeral keys")]),_vm._v(". They are freshly generated, behind the curtains, for each new client ↔ server connection. For this reason you do not have to worry about these and you can just ignore the fact that they exist.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Static keys")]),_vm._v(". Clients and servers can be required to have their own long-term static key in case the handshake pattern in use requires them to authenticate themselves. If this is the case, they will need to generate a static key pair once (and only once) and use it for authenticating themselves during handshakes.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Root signing keys")]),_vm._v(". These are authoritative keys that sign the static keys in setups where static public keys are not known in advance to the other peer. These are similar to the internet's certificate authorities.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Generation and Storage")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Static keys")]),_vm._v(" can be generated via a call to "),_c('a',{attrs:{"href":"https://godoc.org/github.com/mimoo/disco/libdisco#GenerateKeypair"}},[_c('code',[_vm._v("GenerateKeypair(nil)")])]),_vm._v(". The package also provides some file utility functions:\n")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"https://godoc.org/github.com/mimoo/disco/libdisco#KeyPair.ExportPublicKey"}},[_c('code',[_vm._v("KeyPair.ExportPublicKey()")])]),_vm._v(" retrieves the public part of a static key pair.")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://godoc.org/github.com/mimoo/disco/libdisco#GenerateAndSaveDiscoKeyPair"}},[_c('code',[_vm._v("GenerateAndSaveDiscoKeyPair()")])]),_vm._v(" creates and saves a static key pair on disk.")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://godoc.org/github.com/mimoo/disco/libdisco#LoadDiscoKeyPair"}},[_c('code',[_vm._v("LoadDiscoKeyPair(discoPrivateKeyPairFile()")])]),_vm._v(" loads a static key pair from such a file.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Root signing keys")]),_vm._v(" can be generated and saved on disk directly via the "),_c('a',{attrs:{"href":"https://godoc.org/github.com/mimoo/disco/libdisco#GenerateAndSaveDiscoRootKeyPair"}},[_c('code',[_vm._v("GenerateAndSaveDiscoRootKeyPair()")])]),_vm._v(" function. As different peers might need different parts, the private and public parts of the key pair will be saved in different files. To retrieve them you can use the "),_c('a',{attrs:{"href":"https://godoc.org/github.com/mimoo/disco/libdisco#LoadDiscoRootPublicKey"}},[_c('code',[_vm._v("LoadDiscoRootPublicKey()")])]),_vm._v(" and "),_c('a',{attrs:{"href":"https://godoc.org/github.com/mimoo/disco/libdisco#LoadDiscoRootPrivateKey"}},[_c('code',[_vm._v("LoadDiscoRootPrivateKey()")])]),_vm._v(" functions.\n")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-header"},[_c('p',[_vm._v("Storing keys")])]),_vm._v(" "),_c('div',{staticClass:"message-body"},[_vm._v("\n\t    Private part of key pairs should be stored in secure places. Such sensitive information should not be checked in version control systems like git or svn. Instead, they can be stored outside of the program's repository, or passed as environment variables.\n\t  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Configuration of Peers")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("if err := libdisco.GenerateAndSaveDiscoRootKeyPair(\"./discoRootPrivateKey\", \"./discoRootPublicKey\"); err != nil {\n  panic(\"didn't work\")\n}")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-header"},[_c('p',[_vm._v("Storing root keys")])]),_vm._v(" "),_c('div',{staticClass:"message-body"},[_vm._v("\n\t    Note that in this example the private key of the root signing key pair is stored on disk next to the application. Extra care should be taken so that this private key stays accessible only to the root signing program, and inaccessible from the peers (clients and servers).\n\t  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// we load the private part of the root signing key\nrootPrivateKey, err := libdisco.LoadDiscoRootPrivateKey(\"./discoRootPrivateKey\")\nif err != nil {\n  panic(\"couldn't load the root signing private key\")\n}\n// we compute our proof over the server's public static key\nproof := libdisco.CreateStaticPublicKeyProof(rootPrivateKey, serverKeyPair.PublicKey[:])")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("serverConfig := libdisco.Config{\n  HandshakePattern:     libdisco.NoiseNX,\n  KeyPair:              serverKeyPair,\n  StaticPublicKeyProof: proof,\n}")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("4. once the "),_c('code',[_vm._v("discoRootPublicKey")]),_vm._v(" file has been passed to the client, we can configure it:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// we load the public part of the root signing key\nrootPublicKey, err := LoadDiscoRootPublicKey(\"./discoRootPublicKey\")\nif err != nil {\n  panic(\"didn't work\")\n}\n\n// we create our verifier\nsomeCallbackFunction := CreatePublicKeyVerifier(rootPublicKey)\n\n// we configure the client\nclientConfig := libdisco.Config{\n  HandshakePattern:  libdisco.NoiseNK,\n  PublicKeyVerifier: someCallbackFunction,\n}\n")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("For more example please check each handshake pattern individually on the examples on the "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/tree/master/libdisco/examples","target":"_blank"}},[_vm._v("source code repository")])])}]
var Keys_esExports = { render: Keys_render, staticRenderFns: Keys_staticRenderFns }
/* harmony default export */ var components_Keys = (Keys_esExports);
// CONCATENATED MODULE: ./src/components/Keys.vue
var Keys_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Keys___vue_template_functional__ = false
/* styles */
var Keys___vue_styles__ = null
/* scopeId */
var Keys___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Keys___vue_module_identifier__ = null
var Keys_Component = Keys_normalizeComponent(
  Keys,
  components_Keys,
  Keys___vue_template_functional__,
  Keys___vue_styles__,
  Keys___vue_scopeId__,
  Keys___vue_module_identifier__
)

/* harmony default export */ var src_components_Keys = (Keys_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/handshakes/Noise_K.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Noise_K = ({
	name: 'Noise_K',
	data: function data() {
		return {
			pattern: {}
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		patterns_default.a.forEach(function (pattern) {
			if (pattern.name == "Noise_K") {
				_this.pattern = pattern;
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4b18312","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handshakes/Noise_K.vue
var Noise_K_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fas fa-exchange-alt"}),_vm._v(" "+_vm._s(_vm.pattern.name)+" "),_vm._l((_vm.pattern.tags),function(tag){return _c('span',{staticClass:"tag"},[_vm._v(_vm._s(tag))])})],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.pattern.description)}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("+QSb"),"alt":"Noise_K handshake"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("If only one side needs to be authenticated, refer to "),_c('router-link',{attrs:{"to":"/protocol/Noise_N"}},[_vm._v("Noise_N")]),_vm._v(".")],1),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',[_vm._v("In addition, every time the client and server are ran,  they are generating new static key pairs. In practice this should only be done once, possibly using the "),_c('router-link',{attrs:{"to":"protocol/Keys"}},[_vm._v("key helper functions")]),_vm._v(" that libdisco provides.")],1),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('h3',[_vm._v("server:")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('h3',[_vm._v("client:")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('h3',[_vm._v("Security Considerations")]),_vm._v(" "),_vm._m(8)])}
var Noise_K_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Use cases")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Like any one-way pattern. If the server never needs to (or cannot) reply to the client, Noise_K might be a good fit. In addition, this handshake authenticates both side of the connection via "),_c('strong',[_vm._v("public-key pinning")]),_vm._v(". This means that both sides need to know in advance each other's static public key.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Example of configuration")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("To configure both the client and the server, they need to have each other's public static key. In this example we just pass these as "),_c('code',[_vm._v("stdin")]),_vm._v(" argument to each CLI, but in practice these should be hardcoded.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You can play with the full example "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/tree/master/libdisco/examples/Noise_K"}},[_vm._v("here")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// generating the server key pair\nserverKeyPair := libdisco.GenerateKeypair(nil)\nfmt.Println(\"server's public key:\", serverKeyPair.ExportPublicKey())\n\n// configuring the Disco connection\nserverConfig := libdisco.Config{\n\tHandshakePattern: libdisco.NoiseK,\n\tKeyPair:          serverKeyPair,\n}\n\n// retrieve the client's public key from an argument\nfmt.Println(\"please enter the client's public key in hexadecimal\")\nscanner := bufio.NewScanner(os.Stdin)\nscanner.Scan()\nclientKey, _ := hex.DecodeString(scanner.Text())\nserverConfig.RemoteKey = clientKey\n\n// listen on port 6666\nlistener, err := libdisco.Listen(\"tcp\", \"127.0.0.1:6666\", &serverConfig)\nif err != nil {\n\tfmt.Println(\"cannot setup a listener on localhost:\", err)\n\treturn\n}\nfmt.Println(\"listening on:\", listener.Addr().String())")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// generating the client key pair\nclientKeyPair := libdisco.GenerateKeypair(nil)\nfmt.Println(\"client's public key:\", clientKeyPair.ExportPublicKey())\n\n// configure the Disco connection\nclientConfig := libdisco.Config{\n\tHandshakePattern: libdisco.NoiseK,\n\tKeyPair:          clientKeyPair,\n}\n\n// retrieve the server's public key from an argument\nfmt.Println(\"please enter the server's public key in hexadecimal\")\nscanner := bufio.NewScanner(os.Stdin)\nscanner.Scan()\nserverKey, _ := hex.DecodeString(scanner.Text())\nclientConfig.RemoteKey = serverKey\n\n// Dial the port 6666 of localhost\nclient, err := libdisco.Dial(\"tcp\", \"127.0.0.1:6666\", &clientConfig)\nif err != nil {\n\tfmt.Println(\"client can't connect to server:\", err)\n\treturn\n}\ndefer client.Close()\nfmt.Println(\"connected to\", client.RemoteAddr())")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The same security discussed in the "),_c('a',{attrs:{"href":"https://noiseprotocol.org/noise.html#payload-security-properties"}},[_vm._v("Noise specification")]),_vm._v(" for the relevant handshake pattern apply.")])}]
var Noise_K_esExports = { render: Noise_K_render, staticRenderFns: Noise_K_staticRenderFns }
/* harmony default export */ var handshakes_Noise_K = (Noise_K_esExports);
// CONCATENATED MODULE: ./src/components/handshakes/Noise_K.vue
var Noise_K_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Noise_K___vue_template_functional__ = false
/* styles */
var Noise_K___vue_styles__ = null
/* scopeId */
var Noise_K___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Noise_K___vue_module_identifier__ = null
var Noise_K_Component = Noise_K_normalizeComponent(
  Noise_K,
  handshakes_Noise_K,
  Noise_K___vue_template_functional__,
  Noise_K___vue_styles__,
  Noise_K___vue_scopeId__,
  Noise_K___vue_module_identifier__
)

/* harmony default export */ var components_handshakes_Noise_K = (Noise_K_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/handshakes/Noise_N.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Noise_N = ({
	name: 'Noise_N',
	data: function data() {
		return {
			pattern: {}
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		patterns_default.a.forEach(function (pattern) {
			if (pattern.name == "Noise_N") {
				_this.pattern = pattern;
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afdd4376","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handshakes/Noise_N.vue
var Noise_N_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fas fa-exchange-alt"}),_vm._v(" "+_vm._s(_vm.pattern.name)+" "),_vm._l((_vm.pattern.tags),function(tag){return _c('span',{staticClass:"tag"},[_vm._v(_vm._s(tag))])})],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.pattern.description)}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("HD75"),"alt":"Noise_N handshake"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("This handshake pattern is useful for clients that always talk to a single server. In addition, since it is a one-way pattern, the server never talks back to them. The server also doesn't require the client to authenticate itself.")]),_vm._v(" "),_c('p',[_vm._v("If client authentication is needed, refer to "),_c('router-link',{attrs:{"to":"/protocol/Noise_K"}},[_vm._v("Noise_K")]),_vm._v(" or "),_c('router-link',{attrs:{"to":"/protocol/Noise_X"}},[_vm._v("Noise_X")]),_vm._v(".")],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',[_vm._v("In addition, every time the server is ran it is generating a new static key pair. In practice this should only be done once, possibly using the "),_c('router-link',{attrs:{"to":"protocol/Keys"}},[_vm._v("key helper functions")]),_vm._v(" that libdisco provides.")],1),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h3',[_vm._v("server:")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('h3',[_vm._v("client:")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('h3',[_vm._v("Security Considerations")]),_vm._v(" "),_vm._m(7)])}
var Noise_N_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Use cases")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Example of configuration")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The client needs to have prior knowledge to the server's public static key. In this example we just pass it as an "),_c('code',[_vm._v("stdin")]),_vm._v(" argument to the client's CLI, but in practice it should be hardcoded.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You can play with the full example "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/tree/master/libdisco/examples/Noise_N"}},[_vm._v("here")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// generating the server key pair\nserverKeyPair := libdisco.GenerateKeypair(nil)\n\n// configuring the Disco connection with a Noise_N handshake\n// in which the client already knows the server's static public key\nserverConfig := libdisco.Config{\n\tHandshakePattern: libdisco.NoiseN,\n\tKeyPair:          serverKeyPair,\n}\n// listen on port 6666\nlistener, err := libdisco.Listen(\"tcp\", \"127.0.0.1:6666\", &serverConfig)\nif err != nil {\n\tfmt.Println(\"cannot setup a listener on localhost:\", err)\n\treturn\n}\naddr := listener.Addr().String()\nfmt.Println(\"listening on:\", addr)\n// export public key so that client can retrieve it out of band\nfmt.Println(\"server's public key:\", serverKeyPair.ExportPublicKey())")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// retrieve the server's public key from an argument\nserverPubKey := os.Args[1]\nserverKey, _ := hex.DecodeString(serverPubKey)\n\n// configure the Disco connection with Noise_N\n// meaning the client knows the server's static public key (retrieved from the CLI)\nclientConfig := libdisco.Config{\n\tHandshakePattern: libdisco.NoiseN,\n\tRemoteKey:        serverKey,\n}\n// Dial the port 6666 of localhost\nclient, err := libdisco.Dial(\"tcp\", \"127.0.0.1:6666\", &clientConfig)\nif err != nil {\n\tfmt.Println(\"client can't connect to server:\", err)\n\treturn\n}\ndefer client.Close()\nfmt.Println(\"connected to\", client.RemoteAddr())")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The same security discussed in the "),_c('a',{attrs:{"href":"https://noiseprotocol.org/noise.html#payload-security-properties"}},[_vm._v("Noise specification")]),_vm._v(" for the relevant handshake pattern apply.")])}]
var Noise_N_esExports = { render: Noise_N_render, staticRenderFns: Noise_N_staticRenderFns }
/* harmony default export */ var handshakes_Noise_N = (Noise_N_esExports);
// CONCATENATED MODULE: ./src/components/handshakes/Noise_N.vue
var Noise_N_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Noise_N___vue_template_functional__ = false
/* styles */
var Noise_N___vue_styles__ = null
/* scopeId */
var Noise_N___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Noise_N___vue_module_identifier__ = null
var Noise_N_Component = Noise_N_normalizeComponent(
  Noise_N,
  handshakes_Noise_N,
  Noise_N___vue_template_functional__,
  Noise_N___vue_styles__,
  Noise_N___vue_scopeId__,
  Noise_N___vue_module_identifier__
)

/* harmony default export */ var components_handshakes_Noise_N = (Noise_N_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/handshakes/Noise_X.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Noise_X = ({
	name: 'Noise_X',
	data: function data() {
		return {
			pattern: {}
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		patterns_default.a.forEach(function (pattern) {
			if (pattern.name == "Noise_X") {
				_this.pattern = pattern;
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a68846a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handshakes/Noise_X.vue
var Noise_X_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fas fa-exchange-alt"}),_vm._v(" "+_vm._s(_vm.pattern.name)+" "),_vm._l((_vm.pattern.tags),function(tag){return _c('span',{staticClass:"tag"},[_vm._v(_vm._s(tag))])})],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.pattern.description)}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("5vhj"),"alt":"Noise_X handshake"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("This handshake pattern is useful when many different clients want to talk to one server while authenticating both side of the connection. In addition, since it is a one-way pattern, the server never talks back to them.")]),_vm._v(" "),_c('p',[_vm._v("If client authentication is not needed, refer to "),_c('router-link',{attrs:{"to":"/protocol/Noise_N"}},[_vm._v("Noise_N")]),_vm._v(". If a single client exist, refer to "),_c('router-link',{attrs:{"to":"/protocol/Noise_K"}},[_vm._v("Noise_K")]),_vm._v(".")],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("The client needs to have prior knowledge to the server's public static key in order to authenticate the server during the handshake phase.")]),_vm._v(" "),_c('p',[_vm._v("As for the client's authentication:")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',[_vm._v("Both can be done using libdisco's "),_c('router-link',{attrs:{"to":"/protocol/Keys"}},[_vm._v("key helper functions")]),_vm._v(".")],1),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h3',[_vm._v("root key:")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('h3',[_vm._v("server:")]),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('h3',[_vm._v("client:")]),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('h3',[_vm._v("Security Considerations")]),_vm._v(" "),_vm._m(14)])}
var Noise_X_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Use cases")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Example of configuration")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("the client needs to have its public static key signed by an authoritative key pair")]),_vm._v(" "),_c('li',[_vm._v("the server needs to be aware of the authoritative public key")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You can play with the full example "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/tree/master/libdisco/examples/Noise_N"}},[_vm._v("here")]),_vm._v(". The root signing key process is illustrated "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/blob/master/libdisco/examples/RootSigningKeys/root.go"}},[_vm._v("here")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The authoritative root signing key can be generated using libdisco's "),_c('code',[_vm._v("GenerateAndSaveDiscoRootKeyPair")]),_vm._v(" helper function")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// generating the root signing key\nif err := libdisco.GenerateAndSaveDiscoRootKeyPair(\"./privateRoot\", \"./publicRoot\"); err != nil {\n\tpanic(\"cannot generate and save a root key\")\n}")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("This function ("),_c('a',{attrs:{"href":"https://godoc.org/github.com/mimoo/disco/libdisco#GenerateAndSaveDiscoRootKeyPair"}},[_vm._v("documented here")]),_vm._v(") will create two files, a \"privateRoot\" (resp. \"publicRoot\") file containing the private (resp. public) part of the root signing key pair.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The public part can then be retrieved via the "),_c('code',[_vm._v("LoadDiscoRootPublicKey")]),_vm._v(" function.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// loading the public part\npubkey, err := libdisco.LoadDiscoRootPublicKey(\"./publicRoot\")\nif err != nil {\n\t// cannot load the disco root pubkey\n}\n\n// displaying the public part\nfmt.Println(hex.EncodeToString(pubkey))")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("To sign a peer's static public key, the "),_c('code',[_vm._v("CreateStaticPublicKeyProof")]),_vm._v(" function can be used.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// load the private root key\nprivkey, err := libdisco.LoadDiscoRootPrivateKey(\"./privateRoot\")\nif err != nil {\n\t// couldn't load the private root key\n}\n\n// create proof where toSign is a peer's static public key\nproof := libdisco.CreateStaticPublicKeyProof(privkey, toSign)\n\n// display the proof\nfmt.Println(hex.EncodeToString(proof))")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// load the server's keypair\nserverKeyPair, err := libdisco.LoadDiscoKeyPair(\"./serverKeyPair\")\nif err != nil {\n\tfmt.Println(\"couldn't load the server's key pair\")\n\treturn\n}\n\n// retrieve the root signing public key\nrootPublicKey, err := hex.DecodeString(...)\nif err != nil || len(rootPublicKey) != 32 {\n\tfmt.Println(\"public root key passed is not a 32-byte value in hexadecimal (\", len(rootPublicKey), \")\")\n\treturn\n}\n\n// create a verifier for when we will receive the server's public key\nverifier := libdisco.CreatePublicKeyVerifier(rootPublicKey)\n\n// configuring the Disco connection\n// in which the client already knows the server's public key\nserverConfig := libdisco.Config{\n\tHandshakePattern:  libdisco.NoiseX,\n\tKeyPair:           serverKeyPair,\n\tPublicKeyVerifier: verifier,\n}\n\n// listen on port 6666\nlistener, err := libdisco.Listen(\"tcp\", \"127.0.0.1:6666\", &serverConfig)\nif err != nil {\n\tfmt.Println(\"cannot setup a listener on localhost:\", err)\n\treturn\n}\naddr := listener.Addr().String()\nfmt.Println(\"listening on:\", addr)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// load the client's keypair\nclientKeyPair, err := libdisco.LoadDiscoKeyPair(\"./clientkeyPair\")\nif err != nil {\n\tfmt.Println(\"couldn't load the client's key pair\")\n\treturn\n}\n\n// retrieve server's static public key\nserverPublicKey, err := hex.DecodeString(...)\nif err != nil || len(serverPublicKey) != 32 {\n\tfmt.Println(\"server's static public key passed is not a 32-byte value in hexadecimal (\", len(serverPublicKey), \")\")\n\treturn\n}\n\n// retrieve signature/proof over the client's static public key\nproof, err := hex.DecodeString(...)\nif err != nil || len(proof) != 64 {\n\tfmt.Println(\"proof passed is not a 64-byte value in hexadecimal (\", len(proof), \")\")\n\treturn\n}\n\n// configure the Disco connection with Noise_XX\nclientConfig := libdisco.Config{\n\tKeyPair:              clientKeyPair,\n\tRemoteKey:            serverPublicKey,\n\tHandshakePattern:     libdisco.NoiseX,\n\tStaticPublicKeyProof: proof,\n}\n\n// Dial the port 6666 of localhost\nclient, err := libdisco.Dial(\"tcp\", \"127.0.0.1:6666\", &clientConfig)\nif err != nil {\n\tfmt.Println(\"client can't connect to server:\", err)\n\treturn\n}\ndefer client.Close()\nfmt.Println(\"connected to\", client.RemoteAddr())")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The same security discussed in the "),_c('a',{attrs:{"href":"https://noiseprotocol.org/noise.html#payload-security-properties"}},[_vm._v("Noise specification")]),_vm._v(" for the relevant handshake pattern apply.")])}]
var Noise_X_esExports = { render: Noise_X_render, staticRenderFns: Noise_X_staticRenderFns }
/* harmony default export */ var handshakes_Noise_X = (Noise_X_esExports);
// CONCATENATED MODULE: ./src/components/handshakes/Noise_X.vue
var Noise_X_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Noise_X___vue_template_functional__ = false
/* styles */
var Noise_X___vue_styles__ = null
/* scopeId */
var Noise_X___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Noise_X___vue_module_identifier__ = null
var Noise_X_Component = Noise_X_normalizeComponent(
  Noise_X,
  handshakes_Noise_X,
  Noise_X___vue_template_functional__,
  Noise_X___vue_styles__,
  Noise_X___vue_scopeId__,
  Noise_X___vue_module_identifier__
)

/* harmony default export */ var components_handshakes_Noise_X = (Noise_X_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/handshakes/Noise_NNpsk2.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Noise_NNpsk2 = ({
	name: 'Noise_NNpsk2',
	data: function data() {
		return {
			pattern: {}
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		patterns_default.a.forEach(function (pattern) {
			if (pattern.name == "Noise_NNpsk2") {
				_this.pattern = pattern;
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dc3371c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handshakes/Noise_NNpsk2.vue
var Noise_NNpsk2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fas fa-exchange-alt"}),_vm._v(" "+_vm._s(_vm.pattern.name)+" "),_vm._l((_vm.pattern.tags),function(tag){return _c('span',{staticClass:"tag"},[_vm._v(_vm._s(tag))])})],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.pattern.description)}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("rYHo"),"alt":"Noise_NNpsk2 handshake"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("If you are only dealing with one client and one server, and can manually hardcode a common 32-byte random value on each peer, you probably do not need to deal with public keys and should use this handshake pattern.")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',[_vm._v("The shared secret can be generated using a cryptographically random number generator (see "),_c('router-link',{attrs:{"to":"/library/RandomNumers"}},[_vm._v("Generating Random Numbers")]),_vm._v("). It then needs to be manually hardcoded on each peer's.")],1),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h3',[_vm._v("server:")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('h3',[_vm._v("client:")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('h3',[_vm._v("Security Considerations")]),_vm._v(" "),_vm._m(7)])}
var Noise_NNpsk2_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Use cases")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-header"},[_c('p',[_vm._v("Security Consideration")])]),_vm._v(" "),_c('div',{staticClass:"message-body"},[_vm._v("\n\t\t    The same amount of care as with private keys should be taken to store and protect shared secrets.\n\t\t  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Example of configuration")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You can play with the full example "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/tree/master/libdisco/examples/Noise_NNpsk2"}},[_vm._v("here")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// configuring the Disco connection\nserverConfig := libdisco.Config{\n\tHandshakePattern: libdisco.NoiseNNpsk2,\n\t// your 32-byte shared secret\n\tPreSharedKey: sharedSecret,\n}\n\n// listen on port 6666\nlistener, err := libdisco.Listen(\"tcp\", \"127.0.0.1:6666\", &serverConfig)\nif err != nil {\n\tfmt.Println(\"cannot setup a listener on localhost:\", err)\n\treturn\n}\naddr := listener.Addr().String()\nfmt.Println(\"listening on:\", addr)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// configure the Disco connection\nclientConfig := libdisco.Config{\n\tHandshakePattern: libdisco.NoiseNNpsk2,\n\t// your 32-byte shared secret\n\tPreSharedKey: sharedSecret,\n}\n\n// Dial the port 6666 of localhost\nclient, err := libdisco.Dial(\"tcp\", \"127.0.0.1:6666\", &clientConfig)\nif err != nil {\n\tfmt.Println(\"client can't connect to server:\", err)\n\treturn\n}\ndefer client.Close()\nfmt.Println(\"connected to\", client.RemoteAddr())")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The same security discussed in the "),_c('a',{attrs:{"href":"https://noiseprotocol.org/noise.html#payload-security-properties"}},[_vm._v("Noise specification")]),_vm._v(" for the relevant handshake pattern apply.")])}]
var Noise_NNpsk2_esExports = { render: Noise_NNpsk2_render, staticRenderFns: Noise_NNpsk2_staticRenderFns }
/* harmony default export */ var handshakes_Noise_NNpsk2 = (Noise_NNpsk2_esExports);
// CONCATENATED MODULE: ./src/components/handshakes/Noise_NNpsk2.vue
var Noise_NNpsk2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Noise_NNpsk2___vue_template_functional__ = false
/* styles */
var Noise_NNpsk2___vue_styles__ = null
/* scopeId */
var Noise_NNpsk2___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Noise_NNpsk2___vue_module_identifier__ = null
var Noise_NNpsk2_Component = Noise_NNpsk2_normalizeComponent(
  Noise_NNpsk2,
  handshakes_Noise_NNpsk2,
  Noise_NNpsk2___vue_template_functional__,
  Noise_NNpsk2___vue_styles__,
  Noise_NNpsk2___vue_scopeId__,
  Noise_NNpsk2___vue_module_identifier__
)

/* harmony default export */ var components_handshakes_Noise_NNpsk2 = (Noise_NNpsk2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/handshakes/Noise_KK.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Noise_KK = ({
	name: 'Noise_KK',
	data: function data() {
		return {
			pattern: {}
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		patterns_default.a.forEach(function (pattern) {
			if (pattern.name == "Noise_KK") {
				_this.pattern = pattern;
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-002ac3df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handshakes/Noise_KK.vue
var Noise_KK_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fas fa-exchange-alt"}),_vm._v(" "+_vm._s(_vm.pattern.name)+" "),_vm._l((_vm.pattern.tags),function(tag){return _c('span',{staticClass:"tag"},[_vm._v(_vm._s(tag))])})],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.pattern.description)}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("DhZQ"),"alt":"Noise_KK handshake"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("If your protocol involves several peers and both sides of a connection have a way to know the other side's public static key prior to starting the handshake, Noise_KK is a good fit.")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("If your protocol involves a single client and a single server, refer to "),_c('router-link',{attrs:{"to":"/protocol/Noise_NNpsk2"}},[_vm._v("Noise_NNpsk2")]),_vm._v(".")],1),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',[_vm._v("To understand how to generate both peer's key pair, refer to "),_c('router-link',{attrs:{"to":"/protocol/Keys"}},[_vm._v("libdisco's documentation on keys")]),_vm._v(".")],1),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h3',[_vm._v("server:")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('h3',[_vm._v("client:")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('h3',[_vm._v("Security Considerations")]),_vm._v(" "),_vm._m(7)])}
var Noise_KK_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Use cases")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("A simple illustration would be a secure messaging application where the peer's public key can be retrieved in advance via a trusted third party (key server). If the third party cannot be trusted, public keys can be further verified out-of-band (usually via a fingerprint mixing both public keys, see "),_c('a',{attrs:{"href":"https://signal.org/blog/safety-number-updates/","target":"_blank"}},[_vm._v("Signal's safety numbers")]),_vm._v(").")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Example of configuration")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You can play with the full example "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/tree/master/libdisco/examples/Noise_KK"}},[_vm._v("here")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("serverConfig := libdisco.Config{\n\tHandshakePattern: libdisco.NoiseKK,\n\tKeyPair:          serverKeyPair,\n\t// the public static key of the client\n\tRemoteKey: clientPublicKey\n}\n\n// listen on port 6666\nlistener, err := libdisco.Listen(\"tcp\", \"127.0.0.1:6666\", &serverConfig)\nif err != nil {\n\tfmt.Println(\"cannot setup a listener on localhost:\", err)\n\treturn\n}\naddr := listener.Addr().String()\nfmt.Println(\"listening on:\", addr)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("clientConfig := libdisco.Config{\n\tHandshakePattern: libdisco.NoiseKK,\n\tKeyPair:          clientKeyPair,\n\t// the public static key of the server\n\tRemoteKey: serverPublicKey\n}\n\n// Dial the port 6666 of localhost\nclient, err := libdisco.Dial(\"tcp\", \"127.0.0.1:6666\", &clientConfig)\nif err != nil {\n\tfmt.Println(\"client can't connect to server:\", err)\n\treturn\n}\ndefer client.Close()\nfmt.Println(\"connected to\", client.RemoteAddr())")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The same security discussed in the "),_c('a',{attrs:{"href":"https://noiseprotocol.org/noise.html#payload-security-properties"}},[_vm._v("Noise specification")]),_vm._v(" for the relevant handshake pattern apply.")])}]
var Noise_KK_esExports = { render: Noise_KK_render, staticRenderFns: Noise_KK_staticRenderFns }
/* harmony default export */ var handshakes_Noise_KK = (Noise_KK_esExports);
// CONCATENATED MODULE: ./src/components/handshakes/Noise_KK.vue
var Noise_KK_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Noise_KK___vue_template_functional__ = false
/* styles */
var Noise_KK___vue_styles__ = null
/* scopeId */
var Noise_KK___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Noise_KK___vue_module_identifier__ = null
var Noise_KK_Component = Noise_KK_normalizeComponent(
  Noise_KK,
  handshakes_Noise_KK,
  Noise_KK___vue_template_functional__,
  Noise_KK___vue_styles__,
  Noise_KK___vue_scopeId__,
  Noise_KK___vue_module_identifier__
)

/* harmony default export */ var components_handshakes_Noise_KK = (Noise_KK_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/handshakes/Noise_NK.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Noise_NK = ({
	name: 'Noise_NK',
	data: function data() {
		return {
			pattern: {}
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		patterns_default.a.forEach(function (pattern) {
			if (pattern.name == "Noise_NK") {
				_this.pattern = pattern;
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22dd53cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handshakes/Noise_NK.vue
var Noise_NK_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fas fa-exchange-alt"}),_vm._v(" "+_vm._s(_vm.pattern.name)+" "),_vm._l((_vm.pattern.tags),function(tag){return _c('span',{staticClass:"tag"},[_vm._v(_vm._s(tag))])})],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.pattern.description)}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("mG7W"),"alt":"Noise_NK handshake"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("Noise_NK is a relevant handshake pattern if your clients already know a server's static public key. This pattern does not authenticate the client nor does it rely on an external root signing key.")]),_vm._v(" "),_c('p',[_vm._v("If the client needs to be authenticated, refer to "),_c('router-link',{attrs:{"to":"/protocol/Noise_KK"}},[_vm._v("Noise_KK")]),_vm._v(". For clients who do not know the server's static public key in advance, refer to "),_c('router-link',{attrs:{"to":"/protocol/Noise_NX"}},[_vm._v("Noise_NX")]),_vm._v(". ")],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("To understand how to generate the server's static key pair and export its public key part, refer to "),_c('router-link',{attrs:{"to":"/protocol/Keys"}},[_vm._v("libdisco's documentation on keys")]),_vm._v(".")],1),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h3',[_vm._v("server:")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h3',[_vm._v("client:")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('h3',[_vm._v("Security Considerations")]),_vm._v(" "),_vm._m(6)])}
var Noise_NK_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Use cases")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Example of configuration")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You can play with the full example "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/tree/master/libdisco/examples/Noise_NK"}},[_vm._v("here")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("serverConfig := libdisco.Config{\n\tHandshakePattern: libdisco.NoiseNK,\n\tKeyPair:          serverKeyPair,\n}\n// listen on port 6666\nlistener, err := libdisco.Listen(\"tcp\", \"127.0.0.1:6666\", &serverConfig)\nif err != nil {\n\tfmt.Println(\"cannot setup a listener on localhost:\", err)\n\treturn\n}\naddr := listener.Addr().String()\nfmt.Println(\"listening on:\", addr)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("clientConfig := libdisco.Config{\n\tHandshakePattern: libdisco.NoiseNK,\n\t// the server's static public key.\n\tRemoteKey:        serverPublicKey,\n}\n// Dial the port 6666 of localhost\nclient, err := libdisco.Dial(\"tcp\", \"127.0.0.1:6666\", &clientConfig)\nif err != nil {\n\tfmt.Println(\"client can't connect to server:\", err)\n\treturn\n}\ndefer client.Close()\nfmt.Println(\"connected to\", client.RemoteAddr())")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The same security discussed in the "),_c('a',{attrs:{"href":"https://noiseprotocol.org/noise.html#payload-security-properties"}},[_vm._v("Noise specification")]),_vm._v(" for the relevant handshake pattern apply.")])}]
var Noise_NK_esExports = { render: Noise_NK_render, staticRenderFns: Noise_NK_staticRenderFns }
/* harmony default export */ var handshakes_Noise_NK = (Noise_NK_esExports);
// CONCATENATED MODULE: ./src/components/handshakes/Noise_NK.vue
var Noise_NK_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Noise_NK___vue_template_functional__ = false
/* styles */
var Noise_NK___vue_styles__ = null
/* scopeId */
var Noise_NK___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Noise_NK___vue_module_identifier__ = null
var Noise_NK_Component = Noise_NK_normalizeComponent(
  Noise_NK,
  handshakes_Noise_NK,
  Noise_NK___vue_template_functional__,
  Noise_NK___vue_styles__,
  Noise_NK___vue_scopeId__,
  Noise_NK___vue_module_identifier__
)

/* harmony default export */ var components_handshakes_Noise_NK = (Noise_NK_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/handshakes/Noise_NX.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Noise_NX = ({
	name: 'Noise_NX',
	data: function data() {
		return {
			pattern: {}
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		patterns_default.a.forEach(function (pattern) {
			if (pattern.name == "Noise_NX") {
				_this.pattern = pattern;
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d1b95f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handshakes/Noise_NX.vue
var Noise_NX_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fas fa-exchange-alt"}),_vm._v(" "+_vm._s(_vm.pattern.name)+" "),_vm._l((_vm.pattern.tags),function(tag){return _c('span',{staticClass:"tag"},[_vm._v(_vm._s(tag))])})],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.pattern.description)}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Xx17"),"alt":"Noise_NX handshake"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("Noise_NX is a fitting handshake pattern if:")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("if a server's public key is known prior to starting the handshake, refer to "),_c('router-link',{attrs:{"to":"/protocol/Noise_NK"}},[_vm._v("Noise_NK")]),_vm._v(". If clients need to authenticate themselves, refer to "),_c('router-link',{attrs:{"to":"/protocol/Noise_XX"}},[_vm._v("Noise_XX")]),_vm._v(".")],1),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',[_vm._v("Noise_NX requires the server to authenticate itself as part of the handshake. For this to work:")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',[_vm._v("Both of these requirements can be achieved using libdisco's "),_c('router-link',{attrs:{"to":"/protocol/Keys"}},[_vm._v("key helper functions")]),_vm._v(".")],1),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('h3',[_vm._v("root key:")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('h3',[_vm._v("server:")]),_vm._v(" "),_c('p',[_vm._v("As part of Noise_NX, the server needs to be configured with a static public key, as well as a signature over that key.")]),_vm._v(" "),_c('p',[_vm._v("To keep things simple, libdisco provides "),_c('router-link',{attrs:{"to":"/protocol/Keys"}},[_vm._v("utility functions")]),_vm._v(" to avoid X.509 certificates. These utility functions simply allow you to construct a signature over a public static key and to verify such signatures:")],1),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('article',{staticClass:"message is-info"},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"message-body"},[_vm._v("\n\t\t    Similarly to our typical browser ↔ HTTPS webserver scenario, a proof could also be an X.509 certificate containing the "),_c('code',[_vm._v("serverKeyPair")]),_vm._v(" as well as a signature of the certificate from a certificate authority's public key.  If such a complex public key infrastructure is required, you can construct the "),_c('code',[_vm._v("PublicKeyVerifier")]),_vm._v(" and "),_c('code',[_vm._v("StaticPublicKeyProof")]),_vm._v(" yourself to verify a certificate's signature and accept certificates as proofs. See the "),_c('router-link',{attrs:{"to":"/protocol/Overview"}},[_vm._v("Configuration section of the protocol Overview")]),_vm._v(".\n\t\t  ")],1)]),_vm._v(" "),_c('p',[_vm._v("Once the proof has been computed, it can be passed to the server which will be able to configure itself for a Noise_NX setup:")]),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('h3',[_vm._v("client:")]),_vm._v(" "),_c('p',[_vm._v("the client needs to be configured with a function capable of acting on the static public key the server will send (as part of the handshake). Without this, there are no guarantees that the static public key the server sends is \"legit\".")]),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('p',[_vm._v("Finally the full example for a client:")]),_vm._v(" "),_vm._m(19),_vm._v(" "),_c('h3',[_vm._v("Security Considerations")]),_vm._v(" "),_vm._m(20)])}
var Noise_NX_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Use cases")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("clients talk to several servers with no prior knowledge of their public keys")]),_vm._v(" "),_c('li',[_vm._v("clients do not authenticate themselves")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Example of configuration")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("the server needs to have its public static key signed by an authoritative key pair")]),_vm._v(" "),_c('li',[_vm._v("the client needs to be aware of the authoritative public key")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You can play with the full example "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/tree/master/libdisco/examples/Noise_NX"}},[_vm._v("here")]),_vm._v(". The root signing key process is illustrated "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/blob/master/libdisco/examples/RootSigningKeys/root.go"}},[_vm._v("here")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The authoritative root signing key can be generated using libdisco's "),_c('code',[_vm._v("GenerateAndSaveDiscoRootKeyPair")]),_vm._v(" helper function")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// generating the root signing key\nif err := libdisco.GenerateAndSaveDiscoRootKeyPair(\"./privateRoot\", \"./publicRoot\"); err != nil {\n\tpanic(\"cannot generate and save a root key\")\n}")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("This function ("),_c('a',{attrs:{"href":"https://godoc.org/github.com/mimoo/disco/libdisco#GenerateAndSaveDiscoRootKeyPair"}},[_vm._v("documented here")]),_vm._v(") will create two files, a \"privateRoot\" (resp. \"publicRoot\") file containing the private (resp. public) part of the root signing key pair.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The public part can then be retrieved via the "),_c('code',[_vm._v("LoadDiscoRootPublicKey")]),_vm._v(" function.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// loading the public part\npubkey, err := libdisco.LoadDiscoRootPublicKey(\"./publicRoot\")\nif err != nil {\n\t// cannot load the disco root pubkey\n}\n\n// displaying the public part\nfmt.Println(hex.EncodeToString(pubkey))")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("To sign a peer's static public key, the "),_c('code',[_vm._v("CreateStaticPublicKeyProof")]),_vm._v(" function can be used.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// load the private root key\nprivkey, err := libdisco.LoadDiscoRootPrivateKey(\"./privateRoot\")\nif err != nil {\n\t// couldn't load the private root key\n}\n\n// create proof where toSign is a peer's static public key\nproof := libdisco.CreateStaticPublicKeyProof(privkey, toSign)\n\n// display the proof\nfmt.Println(hex.EncodeToString(proof))")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// CreateStaticPublicKeyProof helps in creating a signature over the peer's static public key\n// for that, it needs the private part of a signing root key pair that is trusted by the client.\nproof := CreateStaticPublicKeyProof(rootPrivateKey, peerPublicKey)\n")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-header"},[_c('p',[_vm._v("Public Key Infrastructure")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("serverConfig := libdisco.Config{\n  HandshakePattern:     libdisco.NoiseNX,\n  KeyPair:              serverKeyPair,\n  StaticPublicKeyProof: proof,\n}\n\n// listen on port 6666\nlistener, err := libdisco.Listen(\"tcp\", \"127.0.0.1:6666\", &serverConfig)\nif err != nil {\n\t// cannot setup a listener on localhost\n}\naddr := listener.Addr().String()\nfmt.Println(\"listening on:\", addr)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("clientConfig := libdisco.Config{\n  HandshakePattern:  libdisco.NoiseNX,\n  PublicKeyVerifier: verifier,\n}")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Again, libdisco provides utility functions to create a useful "),_c('code',[_vm._v("PublicKeyVerifier")]),_vm._v(" callback:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// CreatePublicKeyVerifier helps in creating a callback function that will verify a signature\n// for this it needs the public part of the signing root public key that we trust.\nverifier := CreatePublicKeyVerifier(rootPublicKey)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// create a verifier for when we will receive the server's public key\nverifier := libdisco.CreatePublicKeyVerifier(rootPublicKey)\n\n// configure the Disco connection\nclientConfig := libdisco.Config{\n\tHandshakePattern:  libdisco.NoiseNX,\n\tPublicKeyVerifier: verifier,\n}\n\n// Dial the port 6666 of localhost\nclient, err := libdisco.Dial(\"tcp\", \"127.0.0.1:6666\", &clientConfig)\nif err != nil {\n\t// client can't connect to server\n}\ndefer client.Close()\nfmt.Println(\"connected to\", client.RemoteAddr())")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The same security discussed in the "),_c('a',{attrs:{"href":"https://noiseprotocol.org/noise.html#payload-security-properties"}},[_vm._v("Noise specification")]),_vm._v(" for the relevant handshake pattern apply.")])}]
var Noise_NX_esExports = { render: Noise_NX_render, staticRenderFns: Noise_NX_staticRenderFns }
/* harmony default export */ var handshakes_Noise_NX = (Noise_NX_esExports);
// CONCATENATED MODULE: ./src/components/handshakes/Noise_NX.vue
var Noise_NX_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Noise_NX___vue_template_functional__ = false
/* styles */
var Noise_NX___vue_styles__ = null
/* scopeId */
var Noise_NX___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Noise_NX___vue_module_identifier__ = null
var Noise_NX_Component = Noise_NX_normalizeComponent(
  Noise_NX,
  handshakes_Noise_NX,
  Noise_NX___vue_template_functional__,
  Noise_NX___vue_styles__,
  Noise_NX___vue_scopeId__,
  Noise_NX___vue_module_identifier__
)

/* harmony default export */ var components_handshakes_Noise_NX = (Noise_NX_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/handshakes/Noise_KX.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Noise_KX = ({
	name: 'Noise_NNpsk2',
	data: function data() {
		return {
			pattern: {}
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		patterns_default.a.forEach(function (pattern) {
			if (pattern.name == "Noise_NNpsk2") {
				_this.pattern = pattern;
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6295d583","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handshakes/Noise_KX.vue
var Noise_KX_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title is-1"},[_vm._v("Noise_NNpsk2")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.pattern.description)}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h3',[_vm._v("server:")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h3',[_vm._v("client:")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('h3',[_vm._v("Security Considerations")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("the pre-shared key must be safely stored on both endpoints.")]),_vm._v(" "),_c('li',[_vm._v("you usually do not want to share a single pre-shared key over many endpoints, better ways to do this usually involve a PKI. See "),_c('router-link',{attrs:{"to":"/handshakes/Noise_XX"}},[_vm._v("Noise_XX")]),_vm._v(".")],1)])])}
var Noise_KX_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Use cases")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Example of configuration")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-header"},[_c('p',[_vm._v("Security Consideration")])]),_vm._v(" "),_c('div',{staticClass:"message-body"},[_vm._v("\n\t    Note that in this example the private part of the root signing key is loaded on both peers. In practice, this and the computation of the proof should be done on a different machine.\n\t  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code')])}]
var Noise_KX_esExports = { render: Noise_KX_render, staticRenderFns: Noise_KX_staticRenderFns }
/* harmony default export */ var handshakes_Noise_KX = (Noise_KX_esExports);
// CONCATENATED MODULE: ./src/components/handshakes/Noise_KX.vue
var Noise_KX_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Noise_KX___vue_template_functional__ = false
/* styles */
var Noise_KX___vue_styles__ = null
/* scopeId */
var Noise_KX___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Noise_KX___vue_module_identifier__ = null
var Noise_KX_Component = Noise_KX_normalizeComponent(
  Noise_KX,
  handshakes_Noise_KX,
  Noise_KX___vue_template_functional__,
  Noise_KX___vue_styles__,
  Noise_KX___vue_scopeId__,
  Noise_KX___vue_module_identifier__
)

/* harmony default export */ var components_handshakes_Noise_KX = (Noise_KX_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/handshakes/Noise_XK.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Noise_XK = ({
	name: 'Noise_NNpsk2',
	data: function data() {
		return {
			pattern: {}
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		patterns_default.a.forEach(function (pattern) {
			if (pattern.name == "Noise_NNpsk2") {
				_this.pattern = pattern;
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49113010","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handshakes/Noise_XK.vue
var Noise_XK_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title is-1"},[_vm._v("Noise_NNpsk2")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.pattern.description)}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h3',[_vm._v("server:")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h3',[_vm._v("client:")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('h3',[_vm._v("Security Considerations")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("the pre-shared key must be safely stored on both endpoints.")]),_vm._v(" "),_c('li',[_vm._v("you usually do not want to share a single pre-shared key over many endpoints, better ways to do this usually involve a PKI. See "),_c('router-link',{attrs:{"to":"/handshakes/Noise_XX"}},[_vm._v("Noise_XX")]),_vm._v(".")],1)])])}
var Noise_XK_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Use cases")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Example of configuration")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-header"},[_c('p',[_vm._v("Security Consideration")])]),_vm._v(" "),_c('div',{staticClass:"message-body"},[_vm._v("\n\t    Note that in this example the private part of the root signing key is loaded on both peers. In practice, this and the computation of the proof should be done on a different machine.\n\t  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code')])}]
var Noise_XK_esExports = { render: Noise_XK_render, staticRenderFns: Noise_XK_staticRenderFns }
/* harmony default export */ var handshakes_Noise_XK = (Noise_XK_esExports);
// CONCATENATED MODULE: ./src/components/handshakes/Noise_XK.vue
var Noise_XK_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Noise_XK___vue_template_functional__ = false
/* styles */
var Noise_XK___vue_styles__ = null
/* scopeId */
var Noise_XK___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Noise_XK___vue_module_identifier__ = null
var Noise_XK_Component = Noise_XK_normalizeComponent(
  Noise_XK,
  handshakes_Noise_XK,
  Noise_XK___vue_template_functional__,
  Noise_XK___vue_styles__,
  Noise_XK___vue_scopeId__,
  Noise_XK___vue_module_identifier__
)

/* harmony default export */ var components_handshakes_Noise_XK = (Noise_XK_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/handshakes/Noise_XX.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Noise_XX = ({
  name: 'Noise_XX',
  data: function data() {
    return {
      pattern: {}
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    patterns_default.a.forEach(function (pattern) {
      if (pattern.name == "Noise_XX") {
        _this.pattern = pattern;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a026c7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handshakes/Noise_XX.vue
var Noise_XX_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fas fa-exchange-alt"}),_vm._v(" "+_vm._s(_vm.pattern.name)+" "),_vm._l((_vm.pattern.tags),function(tag){return _c('span',{staticClass:"tag"},[_vm._v(_vm._s(tag))])})],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.pattern.description)}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("g9Xj"),"alt":"Noise_XX handshake"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',[_vm._v("Noise_XX requires both side to authenticate themselves as part of the handshake. For this to work:")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('p',[_vm._v("Both of these requirements can be achieved using libdisco's "),_c('router-link',{attrs:{"to":"/protocol/Keys"}},[_vm._v("key helper functions")]),_vm._v(".")],1),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('h3',[_vm._v("root key:")]),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('h3',[_vm._v("server:")]),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('h3',[_vm._v("client:")]),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('h3',[_vm._v("Security Considerations")]),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20)])}
var Noise_XX_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Use cases")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Any "),_c('code',[_vm._v("X")]),_vm._v(" pattern where a peer authenticate itself via the signature of an authoritative key (like the "),_c('code',[_vm._v("Noise_XX")]),_vm._v(" pattern) is useful when the other peer doesn't know in advance what peer it will communicate to.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("This means that "),_c('code',[_vm._v("Noise_XX")]),_vm._v(" is a good candidate for setups where many clients try to connect to many servers, and none of the clients or servers share the same static key.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Like any "),_c('code',[_vm._v("X")]),_vm._v(" pattern where a static key is sent, the peer needs to also send a proof which is typically a signature over its static public key from an authoritative key (a root key). With "),_c('code',[_vm._v("Noise_XX")]),_vm._v(", both peers need to provide a proof, and they both need to verify each other's proof. libdisco supplies helpers to achieve both functionalities, the following examples demonstrate how to use them.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Example of configuration")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("In the following example of configuration, "),_c('strong',[_vm._v("libdisco's helper functions")]),_vm._v(" are used to create proofs and verify them, as well as to "),_c('a',{attrs:{"href":"https://godoc.org/github.com/mimoo/disco/libdisco#GenerateAndSaveDiscoRootKeyPair"}},[_vm._v("generate the root key")]),_vm._v(" which can create these proofs. Notice that the configuration is the same for both peers as we're using a single root key, but two different root keys (one for the servers and one for the clients) could be used if needed.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("both peers need to have their respective public static key signed by an authoritative keypair")]),_vm._v(" "),_c('li',[_vm._v("both peers need to be aware of the authoritative public key")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You can play with the full example "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/tree/master/libdisco/examples/Noise_XX"}},[_vm._v("here")]),_vm._v(". The root signing key process is illustrated "),_c('a',{attrs:{"href":"https://github.com/mimoo/disco/blob/master/libdisco/examples/RootSigningKeys/root.go"}},[_vm._v("here")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The authoritative root signing key can be generated using libdisco's "),_c('code',[_vm._v("GenerateAndSaveDiscoRootKeyPair")]),_vm._v(" helper function")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// generating the root signing key\nif err := libdisco.GenerateAndSaveDiscoRootKeyPair(\"./privateRoot\", \"./publicRoot\"); err != nil {\n\tpanic(\"cannot generate and save a root key\")\n}")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("This function ("),_c('a',{attrs:{"href":"https://godoc.org/github.com/mimoo/disco/libdisco#GenerateAndSaveDiscoRootKeyPair"}},[_vm._v("documented here")]),_vm._v(") will create two files, a \"privateRoot\" (resp. \"publicRoot\") file containing the private (resp. public) part of the root signing keypair.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The public part can then be retrieved via the "),_c('code',[_vm._v("LoadDiscoRootPublicKey")]),_vm._v(" function.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// loading the public part\npubkey, err := libdisco.LoadDiscoRootPublicKey(\"./publicRoot\")\nif err != nil {\n\t// cannot load the disco root pubkey\n}\n\n// displaying the public part\nfmt.Println(hex.EncodeToString(pubkey))")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("To sign a peer's static public key, the "),_c('code',[_vm._v("CreateStaticPublicKeyProof")]),_vm._v(" function can be used.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// load the private root key\nprivkey, err := libdisco.LoadDiscoRootPrivateKey(\"./privateRoot\")\nif err != nil {\n\t// couldn't load the private root key\n}\n\n// create proof where toSign is a peer's static public key\nproof := libdisco.CreateStaticPublicKeyProof(privkey, toSign)\n\n// display the proof\nfmt.Println(hex.EncodeToString(proof))")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// load the server's keypair\nserverKeyPair, err := libdisco.LoadDiscoKeyPair(\"./serverkeyPair\")\nif err != nil {\n\tfmt.Println(\"couldn't load the server's key pair\")\n\treturn\n}\n\n// create a verifier for when we will receive the server's public key\nverifier := libdisco.CreatePublicKeyVerifier(rootPublicKey)\n\n// configure the Disco connection with Noise_XX\nserverConfig := libdisco.Config{\n\tHandshakePattern:     libdisco.NoiseXX,\n\tKeyPair:              serverKeyPair,\n\tPublicKeyVerifier:    verifier,\n\tStaticPublicKeyProof: proof,\n}\n\n// listen on port 6666\nlistener, err := libdisco.Listen(\"tcp\", \"127.0.0.1:6666\", &serverConfig)\nif err != nil {\n\tfmt.Println(\"cannot setup a listener on localhost:\", err)\n\treturn\n}\naddr := listener.Addr().String()\nfmt.Println(\"listening on:\", addr)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code',[_vm._v("// load the client's keypair\nclientKeyPair, err := libdisco.LoadDiscoKeyPair(\"./clientkeyPair\")\nif err != nil {\n\tfmt.Println(\"couldn't load the client's key pair\")\n\treturn\n}\n\n// create a verifier for when we will receive the server's public key\nverifier := libdisco.CreatePublicKeyVerifier(rootPublicKey)\n\n// configure the Disco connection with Noise_XX\nclientConfig := libdisco.Config{\n\tKeyPair:              clientKeyPair,\n\tHandshakePattern:     libdisco.NoiseXX,\n\tPublicKeyVerifier:    verifier,\n\tStaticPublicKeyProof: proof,\n}\n\n// Dial the port 6666 of localhost\nclient, err := libdisco.Dial(\"tcp\", \"127.0.0.1:6666\", &clientConfig)\nif err != nil {\n\tfmt.Println(\"client can't connect to server:\", err)\n\treturn\n}\ndefer client.Close()\nfmt.Println(\"connected to\", client.RemoteAddr())")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The same security discussed in the "),_c('a',{attrs:{"href":"https://noiseprotocol.org/noise.html#payload-security-properties"}},[_vm._v("Noise specification")]),_vm._v(" for the relevant handshake pattern apply.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("This handshake pattern is tricky (like any "),_c('code',[_vm._v("X")]),_vm._v("-type handshakes) as it requires a Public Key Infrastructure (PKI) where:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("the root signing key is securely generated and kept in a secure location (this is often done via a "),_c('a',{attrs:{"href":"https://en.wikipedia.org/wiki/Key_ceremony"}},[_vm._v("key ceremony")]),_vm._v(")")]),_vm._v(" "),_c('li',[_vm._v("the \"proofs\" (a signature from the root key on a peer's static public key) are generated and passed to the peer in a secure manner")]),_vm._v(" "),_c('li',[_vm._v("keys might need to be revoked. This mean that an additional system needs to detect revocations.")])])}]
var Noise_XX_esExports = { render: Noise_XX_render, staticRenderFns: Noise_XX_staticRenderFns }
/* harmony default export */ var handshakes_Noise_XX = (Noise_XX_esExports);
// CONCATENATED MODULE: ./src/components/handshakes/Noise_XX.vue
var Noise_XX_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Noise_XX___vue_template_functional__ = false
/* styles */
var Noise_XX___vue_styles__ = null
/* scopeId */
var Noise_XX___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Noise_XX___vue_module_identifier__ = null
var Noise_XX_Component = Noise_XX_normalizeComponent(
  Noise_XX,
  handshakes_Noise_XX,
  Noise_XX___vue_template_functional__,
  Noise_XX___vue_styles__,
  Noise_XX___vue_scopeId__,
  Noise_XX___vue_module_identifier__
)

/* harmony default export */ var components_handshakes_Noise_XX = (Noise_XX_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/handshakes/Noise_NNoob.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Noise_NNoob = ({
	name: 'Noise_NNpsk2',
	data: function data() {
		return {
			pattern: {}
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		patterns_default.a.forEach(function (pattern) {
			if (pattern.name == "Noise_NNpsk2") {
				_this.pattern = pattern;
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fe717e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/handshakes/Noise_NNoob.vue
var Noise_NNoob_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title is-1"},[_vm._v("Noise_NNpsk2")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.pattern.description)}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h3',[_vm._v("server:")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h3',[_vm._v("client:")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('h3',[_vm._v("Security Considerations")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("the pre-shared key must be safely stored on both endpoints.")]),_vm._v(" "),_c('li',[_vm._v("you usually do not want to share a single pre-shared key over many endpoints, better ways to do this usually involve a PKI. See "),_c('router-link',{attrs:{"to":"/handshakes/Noise_XX"}},[_vm._v("Noise_XX")]),_vm._v(".")],1)])])}
var Noise_NNoob_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Use cases")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Example of configuration")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-header"},[_c('p',[_vm._v("Security Consideration")])]),_vm._v(" "),_c('div',{staticClass:"message-body"},[_vm._v("\n\t    Note that in this example the private part of the root signing key is loaded on both peers. In practice, this and the computation of the proof should be done on a different machine.\n\t  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_c('code')])}]
var Noise_NNoob_esExports = { render: Noise_NNoob_render, staticRenderFns: Noise_NNoob_staticRenderFns }
/* harmony default export */ var handshakes_Noise_NNoob = (Noise_NNoob_esExports);
// CONCATENATED MODULE: ./src/components/handshakes/Noise_NNoob.vue
var Noise_NNoob_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Noise_NNoob___vue_template_functional__ = false
/* styles */
var Noise_NNoob___vue_styles__ = null
/* scopeId */
var Noise_NNoob___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Noise_NNoob___vue_module_identifier__ = null
var Noise_NNoob_Component = Noise_NNoob_normalizeComponent(
  Noise_NNoob,
  handshakes_Noise_NNoob,
  Noise_NNoob___vue_template_functional__,
  Noise_NNoob___vue_styles__,
  Noise_NNoob___vue_scopeId__,
  Noise_NNoob___vue_module_identifier__
)

/* harmony default export */ var components_handshakes_Noise_NNoob = (Noise_NNoob_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/library/Overview.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var library_Overview = ({
  name: 'libraryOverview'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17a6610a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/library/Overview.vue
var library_Overview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var library_Overview_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" Library Overview")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("libdisco")]),_vm._v(" is based on the "),_c('a',{attrs:{"href":"https://strobe.sourceforge.io/","target":"_blank"}},[_vm._v("Strobe protocol framework")]),_vm._v(" and on "),_c('a',{attrs:{"href":"https://cr.yp.to/ecdh/curve25519-20060209.pdf","target":"_blank"}},[_vm._v("Curve25519")]),_vm._v(". In other words, libdisco supports a diverse range of symmetric and asymmetric cryptographic.\n\t")]),_vm._v(" "),_c('p',[_vm._v("\n\t\tThe different cryptographic operations available are documented in the "),_c('i',{staticClass:"fa fa-bars",attrs:{"aria-hidden":"true"}}),_vm._v(" menu on the left.\n\t")]),_vm._v(" "),_c('p',[_vm._v("\n\t\tMore complex symmetric cryptographic primitives can be built on top of Strobe. For this, use the "),_c('a',{attrs:{"href":"https://github.com/mimoo/StrobeGo","target":"_blank"}},[_vm._v("strobe")]),_vm._v(" package. Note that it is already imported as part of libdisco, so re-importing it and using it won't increase the size of your applications' binaries.\n\t")])])}]
var library_Overview_esExports = { render: library_Overview_render, staticRenderFns: library_Overview_staticRenderFns }
/* harmony default export */ var components_library_Overview = (library_Overview_esExports);
// CONCATENATED MODULE: ./src/components/library/Overview.vue
var library_Overview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var library_Overview___vue_template_functional__ = false
/* styles */
var library_Overview___vue_styles__ = null
/* scopeId */
var library_Overview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var library_Overview___vue_module_identifier__ = null
var library_Overview_Component = library_Overview_normalizeComponent(
  library_Overview,
  components_library_Overview,
  library_Overview___vue_template_functional__,
  library_Overview___vue_styles__,
  library_Overview___vue_scopeId__,
  library_Overview___vue_module_identifier__
)

/* harmony default export */ var src_components_library_Overview = (library_Overview_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e383e94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/library/Hashing.vue
var Hashing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Hashing_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" Hashing")]),_vm._v(" "),_c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")]),_vm._v(" "),_c('p',[_vm._v("libdisco provides a simple hashing primitive that is not compatible with SHA-2 or SHA-3 or other hash functions. This means that the output you will get using libdisco's Hash function will be different. The use case and the security remain equivalent.")]),_vm._v(" "),_c('p',[_vm._v("To obtain the 256-bit hash of some input, perform the following:")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("input := []byte(\"hi, how are you?\")\ndigest := libdisco.Hash(input, 32))")])]),_vm._v(" "),_c('p',[_vm._v("libdisco's hash function is more than just a hash function, it is actually an eXtendable Output Function (XOF) which provides a "),_c('strong',[_vm._v("flexible output length")]),_vm._v(". The minimum has been set to 32 bytes (256 bits) for security reasons, there is no practical maximum. The following example obtains an output of 1000 bytes:")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("input := []byte(\"a very long output\")\ndigest := libdisco.Hash(input, 1000))")])]),_vm._v(" "),_c('p',[_vm._v("If you're planning on running a "),_c('strong',[_vm._v("continuous hash")]),_vm._v(", use "),_c('code',[_vm._v("NewHash")]),_vm._v(" instead:")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("h := NewHash(32)\nh.Write([]byte(\"hi\"))\nh.Write([]byte(\" how are you?\"))\nout1 := h.Sum()\nh.Write([]byte(\" david\"))\nout2 := h.Sum()")])]),_vm._v(" "),_c('p',[_vm._v("The two digests will be equivalent to")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("out1 := libdisco.Hash([]byte(\"hi how are you?\"), 32)\nout2 := libdisco.Hash([]byte(\"hi how are you? david\"), 32)")])]),_vm._v(" "),_c('article',{staticClass:"message is-danger",staticStyle:{"margin":"20px 0"}},[_c('div',{staticClass:"message-header"},[_c('p',[_vm._v("Warning")])]),_vm._v(" "),_c('div',{staticClass:"message-body"},[_vm._v("\n\t\t    the "),_c('code',[_vm._v("Write()")]),_vm._v(" function should be used for hashing contiguous chunks of data. If the data is structured (for example "),_c('code',[_vm._v("age|gender|city")]),_vm._v(") use the "),_c('code',[_vm._v("WriteTuple()")]),_vm._v(" function instead.\n\t\t  ")])])])}]
var Hashing_esExports = { render: Hashing_render, staticRenderFns: Hashing_staticRenderFns }
/* harmony default export */ var Hashing = (Hashing_esExports);
// CONCATENATED MODULE: ./src/components/library/Hashing.vue
var Hashing_normalizeComponent = __webpack_require__("VU/8")
/* script */
var Hashing___vue_script__ = null
/* template */

/* template functional */
var Hashing___vue_template_functional__ = false
/* styles */
var Hashing___vue_styles__ = null
/* scopeId */
var Hashing___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Hashing___vue_module_identifier__ = null
var Hashing_Component = Hashing_normalizeComponent(
  Hashing___vue_script__,
  Hashing,
  Hashing___vue_template_functional__,
  Hashing___vue_styles__,
  Hashing___vue_scopeId__,
  Hashing___vue_module_identifier__
)

/* harmony default export */ var library_Hashing = (Hashing_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-550dd2ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/library/Encryption.vue
var Encryption_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Encryption_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" Encryption")]),_vm._v(" "),_c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")]),_vm._v(" "),_c('p',[_vm._v("To encrypt, simply use the "),_c('code',[_vm._v("Encrypt")]),_vm._v(" function with a key of at minimum 128 bits (16 bytes)")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("key, _ := hex.DecodeString(\"eda8506c1fb0bbcc3f62626fef074bbf2d09a8c7c608f3fa1482c9a625d00f75\")\nplaintext := []byte(\"hello, how are you?\")\n\nciphertext := libdisco.Encrypt(key, plaintext)")])]),_vm._v(" "),_c('p',[_vm._v("To decrypt, use the corresponding "),_c('code',[_vm._v("Decrypt")]),_vm._v(" function with the same key.")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("key, _ := hex.DecodeString(\"eda8506c1fb0bbcc3f62626fef074bbf2d09a8c7c608f3fa1482c9a625d00f75\")\n\ndecrypted, err := libdisco.Decrypt(key, ciphertext)")])])])}]
var Encryption_esExports = { render: Encryption_render, staticRenderFns: Encryption_staticRenderFns }
/* harmony default export */ var Encryption = (Encryption_esExports);
// CONCATENATED MODULE: ./src/components/library/Encryption.vue
var Encryption_normalizeComponent = __webpack_require__("VU/8")
/* script */
var Encryption___vue_script__ = null
/* template */

/* template functional */
var Encryption___vue_template_functional__ = false
/* styles */
var Encryption___vue_styles__ = null
/* scopeId */
var Encryption___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Encryption___vue_module_identifier__ = null
var Encryption_Component = Encryption_normalizeComponent(
  Encryption___vue_script__,
  Encryption,
  Encryption___vue_template_functional__,
  Encryption___vue_styles__,
  Encryption___vue_scopeId__,
  Encryption___vue_module_identifier__
)

/* harmony default export */ var library_Encryption = (Encryption_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d00e5f34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/library/DerivingKeys.vue
var DerivingKeys_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var DerivingKeys_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" Deriving Keys")]),_vm._v(" "),_c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")]),_vm._v(" "),_c('p',[_vm._v("libdisco provides functions to \"spread\" a single key into several keys. The input key must be random and larger or equal to 128 bits (16 bytes) for security reasons. The following snippet takes a 16-byte key and derives two 32-byte keys:")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("input, _ := hex.DecodeString(\"2825a87129f065748121cdf6c1dcf8b7\")\nkeys := libdisco.DeriveKeys(input, 64))\nkey1 := keys[:32]\nkey2 := keys[32:]")])])])}]
var DerivingKeys_esExports = { render: DerivingKeys_render, staticRenderFns: DerivingKeys_staticRenderFns }
/* harmony default export */ var DerivingKeys = (DerivingKeys_esExports);
// CONCATENATED MODULE: ./src/components/library/DerivingKeys.vue
var DerivingKeys_normalizeComponent = __webpack_require__("VU/8")
/* script */
var DerivingKeys___vue_script__ = null
/* template */

/* template functional */
var DerivingKeys___vue_template_functional__ = false
/* styles */
var DerivingKeys___vue_styles__ = null
/* scopeId */
var DerivingKeys___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DerivingKeys___vue_module_identifier__ = null
var DerivingKeys_Component = DerivingKeys_normalizeComponent(
  DerivingKeys___vue_script__,
  DerivingKeys,
  DerivingKeys___vue_template_functional__,
  DerivingKeys___vue_styles__,
  DerivingKeys___vue_scopeId__,
  DerivingKeys___vue_module_identifier__
)

/* harmony default export */ var library_DerivingKeys = (DerivingKeys_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f7ce647","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/library/Signing.vue
var Signing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Signing_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" Signing")]),_vm._v(" "),_c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")]),_vm._v(" "),_c('p',[_vm._v("Asymmetric cryptographic operations in libdisco are built on top of the Curve25519 primitive. Since Golang has standard libraries implementing both ed25519 (for signing) and X25519 (for key exchanges) this is what we use.")]),_vm._v(" "),_c('p',[_vm._v("Please refer to the documentation for "),_c('a',{attrs:{"href":"https://godoc.org/golang.org/x/crypto/ed25519"}},[_vm._v("x/crypto/ed25519")]),_vm._v(" in order to use it.")]),_vm._v(" "),_c('p',[_vm._v("Note that since libdisco already uses these libraries, importing them in your project will not increase the size of the final binaries.")])])}]
var Signing_esExports = { render: Signing_render, staticRenderFns: Signing_staticRenderFns }
/* harmony default export */ var Signing = (Signing_esExports);
// CONCATENATED MODULE: ./src/components/library/Signing.vue
var Signing_normalizeComponent = __webpack_require__("VU/8")
/* script */
var Signing___vue_script__ = null
/* template */

/* template functional */
var Signing___vue_template_functional__ = false
/* styles */
var Signing___vue_styles__ = null
/* scopeId */
var Signing___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Signing___vue_module_identifier__ = null
var Signing_Component = Signing_normalizeComponent(
  Signing___vue_script__,
  Signing,
  Signing___vue_template_functional__,
  Signing___vue_styles__,
  Signing___vue_scopeId__,
  Signing___vue_module_identifier__
)

/* harmony default export */ var library_Signing = (Signing_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29689932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/library/IntegrityProtection.vue
var IntegrityProtection_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var IntegrityProtection_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" Integrity Protection")]),_vm._v(" "),_c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")]),_vm._v(" "),_c('p',[_vm._v("The "),_c('code',[_vm._v("ProtectIntegrity")]),_vm._v(" and "),_c('code',[_vm._v("VerifyIntegrity")]),_vm._v(" functions can be used to make sure that a message has not been tampered with. Note that this creates a payload containing your message in clear. This is not encryption!")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("UjSX"),"alt":"integrity protection"}}),_vm._v(" "),_c('p',[_vm._v("to create your payload with a message:")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("key, _ := hex.DecodeString(\"eda8506c1fb0bbcc3f62626fef074bbf2d09a8c7c608f3fa1482c9a625d00f75\")\n\nmessage := []byte(\"hoy, how are you?\")\n\npayload := ProtectIntegrity(key, message)")])]),_vm._v(" "),_c('p',[_vm._v("to extract your payload use the function "),_c('code',[_vm._v("VerifyIntegrity")]),_vm._v(". It will return an error if the payload has been modified since its creation, otherwise it will return the original message:")]),_vm._v(" "),_c('pre',[_c('code',[_vm._v("retrievedMessage, err := VerifyIntegrity(key, plaintextAndTag)\n\nif err != nil {\n\t// the message was tampered with\n}")])])])}]
var IntegrityProtection_esExports = { render: IntegrityProtection_render, staticRenderFns: IntegrityProtection_staticRenderFns }
/* harmony default export */ var IntegrityProtection = (IntegrityProtection_esExports);
// CONCATENATED MODULE: ./src/components/library/IntegrityProtection.vue
var IntegrityProtection_normalizeComponent = __webpack_require__("VU/8")
/* script */
var IntegrityProtection___vue_script__ = null
/* template */

/* template functional */
var IntegrityProtection___vue_template_functional__ = false
/* styles */
var IntegrityProtection___vue_styles__ = null
/* scopeId */
var IntegrityProtection___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var IntegrityProtection___vue_module_identifier__ = null
var IntegrityProtection_Component = IntegrityProtection_normalizeComponent(
  IntegrityProtection___vue_script__,
  IntegrityProtection,
  IntegrityProtection___vue_template_functional__,
  IntegrityProtection___vue_styles__,
  IntegrityProtection___vue_scopeId__,
  IntegrityProtection___vue_module_identifier__
)

/* harmony default export */ var library_IntegrityProtection = (IntegrityProtection_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37cc269d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/library/RandomNumbers.vue
var RandomNumbers_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var RandomNumbers_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" Random Numbers")]),_vm._v(" "),_c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")]),_vm._v(" "),_c('p',[_vm._v("libdisco uses golang's standard library "),_c('a',{attrs:{"href":"https://golang.org/pkg/crypto/rand/"}},[_vm._v("crypto/rand")]),_vm._v(" to generate random numbers.")]),_vm._v(" "),_c('p',[_vm._v("It is possible to use Strobe to generate random numbers in userland, but it is not advised at forking or cloning a VM snapshot will end up making different programs produce the same random numbers.")])])}]
var RandomNumbers_esExports = { render: RandomNumbers_render, staticRenderFns: RandomNumbers_staticRenderFns }
/* harmony default export */ var RandomNumbers = (RandomNumbers_esExports);
// CONCATENATED MODULE: ./src/components/library/RandomNumbers.vue
var RandomNumbers_normalizeComponent = __webpack_require__("VU/8")
/* script */
var RandomNumbers___vue_script__ = null
/* template */

/* template functional */
var RandomNumbers___vue_template_functional__ = false
/* styles */
var RandomNumbers___vue_styles__ = null
/* scopeId */
var RandomNumbers___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var RandomNumbers___vue_module_identifier__ = null
var RandomNumbers_Component = RandomNumbers_normalizeComponent(
  RandomNumbers___vue_script__,
  RandomNumbers,
  RandomNumbers___vue_template_functional__,
  RandomNumbers___vue_styles__,
  RandomNumbers___vue_scopeId__,
  RandomNumbers___vue_module_identifier__
)

/* harmony default export */ var library_RandomNumbers = (RandomNumbers_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6389dcf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/library/PasswordHashing.vue
var PasswordHashing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var PasswordHashing_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" Storing Password")]),_vm._v(" "),_c('h2',[_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}}),_vm._v(" Description")]),_vm._v(" "),_c('p',[_vm._v("libdisco does not provide this functionnality.")]),_vm._v(" "),_c('p',[_vm._v("Please refer to the "),_c('a',{attrs:{"href":"https://github.com/tvdburgt/go-argon2"}},[_vm._v("Go-argon2")]),_vm._v(" library for this.")])])}]
var PasswordHashing_esExports = { render: PasswordHashing_render, staticRenderFns: PasswordHashing_staticRenderFns }
/* harmony default export */ var PasswordHashing = (PasswordHashing_esExports);
// CONCATENATED MODULE: ./src/components/library/PasswordHashing.vue
var PasswordHashing_normalizeComponent = __webpack_require__("VU/8")
/* script */
var PasswordHashing___vue_script__ = null
/* template */

/* template functional */
var PasswordHashing___vue_template_functional__ = false
/* styles */
var PasswordHashing___vue_styles__ = null
/* scopeId */
var PasswordHashing___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PasswordHashing___vue_module_identifier__ = null
var PasswordHashing_Component = PasswordHashing_normalizeComponent(
  PasswordHashing___vue_script__,
  PasswordHashing,
  PasswordHashing___vue_template_functional__,
  PasswordHashing___vue_styles__,
  PasswordHashing___vue_scopeId__,
  PasswordHashing___vue_module_identifier__
)

/* harmony default export */ var library_PasswordHashing = (PasswordHashing_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js


//


// protocol













// library









vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/',
    name: 'LandingPage',
    component: src_components_LandingPage
  }, {
    path: '/get_started',
    name: 'GetStarted',
    component: components_GetStarted
  },
  // protocol
  {
    path: '/protocol/Overview',
    name: 'protocolOverview',
    component: components_handshakes_Overview
  }, {
    path: '/protocol/Keys',
    name: 'Keys',
    component: src_components_Keys
  }, {
    path: '/protocol/Noise_K',
    name: 'Noise_K',
    component: components_handshakes_Noise_K
  }, {
    path: '/protocol/Noise_N',
    name: 'Noise_N',
    component: components_handshakes_Noise_N
  }, {
    path: '/protocol/Noise_X',
    name: 'Noise_X',
    component: components_handshakes_Noise_X
  }, {
    path: '/protocol/Noise_NNpsk2',
    name: 'Noise_NNpsk2',
    component: components_handshakes_Noise_NNpsk2
  }, {
    path: '/protocol/Noise_KK',
    name: 'Noise_KK',
    component: components_handshakes_Noise_KK
  }, {
    path: '/protocol/Noise_NK',
    name: 'Noise_NK',
    component: components_handshakes_Noise_NK
  }, {
    path: '/protocol/Noise_NX',
    name: 'Noise_NX',
    component: components_handshakes_Noise_NX
  }, {
    path: '/protocol/Noise_KX',
    name: 'Noise_KX',
    component: components_handshakes_Noise_KX
  }, {
    path: '/protocol/Noise_XK',
    name: 'Noise_XK',
    component: components_handshakes_Noise_XK
  }, {
    path: '/protocol/Noise_XX',
    name: 'Noise_XX',
    component: components_handshakes_Noise_XX
  }, {
    path: '/protocol/Noise_NNoob',
    name: 'Noise_NNoob',
    component: components_handshakes_Noise_NNoob
  },
  // library
  {
    path: '/library/Overview',
    name: 'libraryOverview',
    component: src_components_library_Overview
  }, {
    path: '/library/Hashing',
    name: 'Hashing',
    component: library_Hashing
  }, {
    path: '/library/Encryption',
    name: 'Encryption',
    component: library_Encryption
  }, {
    path: '/library/DerivingKeys',
    name: 'DerivingKeys',
    component: library_DerivingKeys
  }, {
    path: '/library/Signing',
    name: 'Signing',
    component: library_Signing
  }, {
    path: '/library/IntegrityProtection',
    name: 'IntegrityProtection',
    component: library_IntegrityProtection
  }, {
    path: '/library/PasswordHashing',
    name: 'PasswordHashing',
    component: library_PasswordHashing
  }, {
    path: '/library/RandomNumbers',
    name: 'RandomNumbers',
    component: library_RandomNumbers
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "UjSX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/integrity.4115fe6.png";

/***/ }),

/***/ "Xx17":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Noise_NX.dd7ef57.png";

/***/ }),

/***/ "ej5v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g9Xj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Noise_XX.06ffda5.png";

/***/ }),

/***/ "mG7W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Noise_NK.aaa1fd8.png";

/***/ }),

/***/ "rYHo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Noise_NNpsk2.0fb9887.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.acdc2256eb9c8d66fbce.js